var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "tab-booking-fcl" } },
    [
      _vm.isFba
        ? _c(
            "el-form",
            {
              staticClass: "section",
              staticStyle: { "flex-direction": "row" },
              attrs: { disabled: _vm.readonly }
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    width: "64px"
                  }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("FbaJob.ValueAddedServices")) + " "
                  )
                ]
              ),
              _c(
                "el-checkbox-group",
                {
                  on: { change: _vm.addedServiceChangeHandler },
                  model: {
                    value: _vm.selectedLocalAddedService,
                    callback: function($$v) {
                      _vm.selectedLocalAddedService = $$v
                    },
                    expression: "selectedLocalAddedService"
                  }
                },
                _vm._l(_vm.localAddedService, function(item) {
                  return _c(
                    "el-checkbox",
                    {
                      key: item.code,
                      staticStyle: {
                        "margin-left": "8px",
                        "margin-right": "8px"
                      },
                      attrs: {
                        label: item.code,
                        disabled: item.code === "signHBL" && _vm.form.mblOnly
                      },
                      on: {
                        change: function(val) {
                          return _vm.singleAddedServiceChangeHandler(val, item)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(item.chineseName) + " ")]
                  )
                }),
                1
              ),
              _vm.isBookingNew
                ? _c(
                    "el-checkbox",
                    {
                      staticStyle: {
                        "margin-left": "8px",
                        "margin-right": "8px"
                      },
                      attrs: { no: "destinationPortService" },
                      on: { change: _vm.destinationPortServiceChange },
                      model: {
                        value: _vm.form.destinationPortService,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "destinationPortService", $$v)
                        },
                        expression: "form.destinationPortService"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.PortOfDestinationServices"))
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      !_vm.isFba
        ? _c(
            "el-form",
            {
              staticClass: "section",
              staticStyle: { "flex-direction": "row" },
              attrs: { disabled: _vm.readonly }
            },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { no: "booking" },
                  model: {
                    value: _vm.form.booking,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "booking", $$v)
                    },
                    expression: "form.booking"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Booking")))]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "customs" },
                  on: {
                    change: function(val) {
                      _vm.form.customsBroker = val ? _vm.form.customsBroker : 0
                      _vm.form.customsDeclarationType = val
                        ? _vm.form.customsDeclarationType
                        : -1
                    }
                  },
                  model: {
                    value: _vm.form.customs,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "customs", $$v)
                    },
                    expression: "form.customs"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.CustomsDeclaration")) + " ")]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "isInsure" },
                  model: {
                    value: _vm.form.insure,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "insure", $$v)
                    },
                    expression: "form.insure"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.InsureInfo")) + " ")]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "signMBL" },
                  on: {
                    change: function($event) {
                      return _vm.pm.isMBLChange()
                    }
                  },
                  model: {
                    value: _vm.form.signMBL,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "signMBL", $$v)
                    },
                    expression: "form.signMBL"
                  }
                },
                [_vm._v("MB/L ")]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "signHBL", disabled: _vm.form.mblOnly },
                  on: {
                    change: function($event) {
                      return _vm.pm.isHBLChange()
                    }
                  },
                  model: {
                    value: _vm.form.signHBL,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "signHBL", $$v)
                    },
                    expression: "form.signHBL"
                  }
                },
                [_vm._v("HB/L ")]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "virtualHBL" },
                  on: {
                    change: function($event) {
                      return _vm.pm.virtualHblChange()
                    }
                  },
                  model: {
                    value: _vm.form.virtualHBL,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "virtualHBL", $$v)
                    },
                    expression: "form.virtualHBL"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.FormalHbl")))]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "vgm" },
                  model: {
                    value: _vm.form.vgm,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "vgm", $$v)
                    },
                    expression: "form.vgm"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Vgm")))]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "ams" },
                  model: {
                    value: _vm.form.ams,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "ams", $$v)
                    },
                    expression: "form.ams"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Anti_terrorismShipping")))]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "hds" },
                  model: {
                    value: _vm.form.hds,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "hds", $$v)
                    },
                    expression: "form.hds"
                  }
                },
                [_vm._v("HDS")]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "comercialInspectation" },
                  model: {
                    value: _vm.form.comercialInspectation,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "comercialInspectation", $$v)
                    },
                    expression: "form.comercialInspectation"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.CommodityInspection")))]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "heating" },
                  model: {
                    value: _vm.form.heating,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "heating", $$v)
                    },
                    expression: "form.heating"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Fumigation")))]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "itmService" },
                  model: {
                    value: _vm.form.itmService,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "itmService", $$v)
                    },
                    expression: "form.itmService"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.ForeignTrade")))]
              ),
              _vm.isBookingNew
                ? _c(
                    "el-checkbox",
                    {
                      staticStyle: { "margin-left": "-20px" },
                      attrs: { no: "destinationPortService" },
                      on: { change: _vm.destinationPortServiceChange },
                      model: {
                        value: _vm.form.destinationPortService,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "destinationPortService", $$v)
                        },
                        expression: "form.destinationPortService"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.PortOfDestinationServices"))
                      )
                    ]
                  )
                : _vm._e(),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "manifest" },
                  model: {
                    value: _vm.form.manifest,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "manifest", $$v)
                    },
                    expression: "form.manifest"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Manifest")))]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "seaRailwayTransportation" },
                  model: {
                    value: _vm.form.seaRailwayTransportation,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "seaRailwayTransportation", $$v)
                    },
                    expression: "form.seaRailwayTransportation"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SeaRailTransport")))]
              )
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticStyle: { width: "fit-content" } }, [
        _c("div", { staticStyle: { display: "flex" } }, [
          this.$store.getters.tenantId === 889
            ? _c(
                "div",
                { staticClass: "section form-column" },
                [
                  _c("micro-app", {
                    attrs: {
                      name: "child-vue2",
                      url: _vm.$store.getters.frontEndPluginUrl + "/item",
                      "router-mode": "pure",
                      destroy: ""
                    }
                  })
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "section form-column" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        disabled: _vm.readonly,
                        "label-width": "133px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.ConsignInfo")))
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.BusinessNo") } },
                        [
                          _c("el-input", {
                            attrs: { value: _vm.form.jobNo, disabled: true }
                          })
                        ],
                        1
                      ),
                      this.$store.getters.tenantId === 889
                        ? _c(
                            "div",
                            [
                              _c("micro-app", {
                                attrs: {
                                  name: "child-operation-date",
                                  url:
                                    _vm.$store.getters.frontEndPluginUrl +
                                    "/operationDateItem",
                                  "router-mode": "pure",
                                  destroy: ""
                                },
                                on: { datachange: _vm.operationDateDataChange }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      this.$store.getters.tenantId === 889
                        ? _c(
                            "div",
                            [
                              _c("micro-app", {
                                attrs: {
                                  name: "child-sale-role-hide",
                                  url:
                                    _vm.$store.getters.frontEndPluginUrl +
                                    "/saleRoleHideItem",
                                  "router-mode": "pure",
                                  destroy: ""
                                },
                                on: { datachange: _vm.saleRoleHideDataChange }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      this.$store.getters.tenantId === 889
                        ? _c(
                            "div",
                            [
                              _c("micro-app", {
                                attrs: {
                                  name: "child-operation-date-query",
                                  url:
                                    _vm.$store.getters.frontEndPluginUrl +
                                    "/operationDateQuery",
                                  "router-mode": "pure",
                                  destroy: ""
                                },
                                on: {
                                  datachange: _vm.operationDateQueryDataChange
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isZY
                        ? [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "blue",
                                    attrs: { slot: "label" },
                                    slot: "label"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.AllowSaleProduct")
                                      )
                                    )
                                  ]
                                ),
                                _c("cargo-advance-select", {
                                  attrs: {
                                    "select-type":
                                      _vm.selectTypeNames
                                        .basic_data_AllowSaleProduct,
                                    filterable: "",
                                    no: "allowSaleProduct",
                                    clearable: "",
                                    "data-filter-function": function(p) {
                                      if (!p.statusEnabled) {
                                        return false
                                      }
                                      return _vm.isFba
                                        ? p.fbaSea
                                        : p.seaExportEnabled
                                    },
                                    "default-value":
                                      this.form.saleProductCode || ""
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      this$1.form.saleProductCode = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "blue",
                                    attrs: { slot: "label" },
                                    slot: "label"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.FullOrInside"))
                                    )
                                  ]
                                ),
                                _c("cargo-advance-select", {
                                  attrs: {
                                    "select-type":
                                      _vm.selectTypeNames
                                        .local_cache_FullOrInside$FULL_OR_INSIDE,
                                    no: "fullOrInside",
                                    clearable: "",
                                    "default-value":
                                      this.form.fullOrInside || ""
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      this$1.form.fullOrInside = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        : _vm._e(),
                      _c("el-form-item", [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.ConsignationCompany"))
                            )
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center"
                            }
                          },
                          [
                            _c(
                              "el-tooltip",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.sopImageB,
                                    expression: "sopImageB"
                                  }
                                ],
                                attrs: {
                                  content: _vm.$t("SeaExport.SOPReceiver"),
                                  placement: "right-end"
                                }
                              },
                              [
                                _c("img", {
                                  staticClass: "sop-img",
                                  class:
                                    _vm.form.customerId && _vm.readonly
                                      ? ""
                                      : "not-click",
                                  staticStyle: {
                                    padding: "5px 0",
                                    "vertical-align": "bottom",
                                    cursor: "pointer"
                                  },
                                  attrs: {
                                    src: _vm.sopPic,
                                    width: "18",
                                    height: "28"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.sopChangeCustomerIdHandler()
                                    }
                                  }
                                })
                              ]
                            ),
                            _c(
                              "el-tooltip",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showWarningImageB,
                                    expression: "showWarningImageB"
                                  }
                                ],
                                attrs: {
                                  content: _vm.warningImageBTip,
                                  placement: "right-end"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-warning red",
                                  staticStyle: { cursor: "pointer" }
                                })
                              ]
                            ),
                            !_vm.isFba
                              ? _c("cargo-sales-company-select", {
                                  ref: "customerSelect",
                                  staticClass: "shipper-selector",
                                  class: _vm.importDifferenceField.customerId
                                    ? "red-border"
                                    : "",
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    no: "customerId",
                                    "popper-class": "shipper-selector-popper",
                                    "method-params": {
                                      customer: true,
                                      companyLob: "seaExport",
                                      active: true
                                    },
                                    "check-credit": true,
                                    "default-value": _vm.form.customerId || "",
                                    disabled: !_vm.customerEnabled,
                                    job: _vm.form
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.customerIdChange2ContractHandler(p)
                                      _vm.clearPoNo()
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm.isFba
                              ? _c("cargo-company-select", {
                                  ref: "customerSelect",
                                  staticClass: "shipper-selector",
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    no: "customerId",
                                    "popper-class": "shipper-selector-popper",
                                    "method-params": {
                                      customer: true,
                                      companyLob: "seaExport",
                                      active: true,
                                      fba: true
                                    },
                                    "check-credit": true,
                                    job: _vm.form,
                                    "default-value": _vm.form.customerId || "",
                                    disabled: !_vm.customerEnabled,
                                    "data-filter-function":
                                      _vm.fbaCustomerIdFilter
                                  },
                                  on: {
                                    change: function(p) {
                                      _vm.customerIdChange2ContractHandler(p)
                                      _vm.clearPoNo()
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.CustomerProperty") }
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: _vm.customerTip,
                                placement: "bottom"
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        (_vm.contractStatus === 2 &&
                                          typeof _vm.customerLevel.level ===
                                            "number") ||
                                        parseInt(_vm.customerLevel.level) > -1,
                                      expression:
                                        "(contractStatus===2&&typeof customerLevel.level==='number')||parseInt(customerLevel.level)>-1"
                                    }
                                  ],
                                  staticClass: "orange"
                                },
                                [_vm._v("LV" + _vm._s(_vm.customerLevel.level))]
                              ),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        (_vm.contractStatus === 2 &&
                                          typeof _vm.customerLevel.level ===
                                            "number") ||
                                        parseInt(_vm.customerLevel.level) > -1,
                                      expression:
                                        "(contractStatus===2&&typeof customerLevel.level==='number')||parseInt(customerLevel.level)>-1"
                                    }
                                  ],
                                  staticStyle: { color: "#D3A73B" }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.customerLevel.customerName)
                                  )
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.contractStatusLabel,
                                      expression: "contractStatusLabel"
                                    }
                                  ],
                                  staticClass: "red"
                                },
                                [
                                  _vm._v(
                                    " (" + _vm._s(_vm.contractStatusLabel) + ")"
                                  )
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.advancePaymentLabel,
                                      expression: "advancePaymentLabel"
                                    }
                                  ],
                                  staticStyle: { color: "brown" }
                                },
                                [
                                  _vm._v(
                                    " (" + _vm._s(_vm.advancePaymentLabel) + ")"
                                  )
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.stampPictureView.businessDocuments
                                          .length > 0,
                                      expression:
                                        "stampPictureView.businessDocuments.length > 0"
                                    }
                                  ],
                                  on: {
                                    click: function($event) {
                                      _vm.stampPictureView.visible = true
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    staticStyle: { "text-align": "right" },
                                    attrs: {
                                      title: _vm.$t("Message.BookingSeal"),
                                      src: _vm.stampIcon,
                                      height: "14"
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.ContactPerson") } },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c(
                                "el-select",
                                {
                                  class: _vm.importDifferenceField
                                    .customerContact
                                    ? "red-border"
                                    : "",
                                  attrs: {
                                    no: "customerContact",
                                    filterable: "",
                                    "allow-create": true
                                  },
                                  model: {
                                    value: _vm.form.customerContact,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "customerContact", $$v)
                                    },
                                    expression: "form.customerContact"
                                  }
                                },
                                _vm._l(_vm.contactList, function(item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.contactPerson,
                                      value: item.contactPerson
                                    }
                                  })
                                }),
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-link",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.isShowContactPersonDetail,
                                      expression: "!isShowContactPersonDetail"
                                    }
                                  ],
                                  class: _vm.form.customerContact
                                    ? ""
                                    : "not-click",
                                  attrs: { no: "customerContactLink" },
                                  on: { click: _vm.showContactDialog }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.Detail")) + " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.FLCLType") } },
                        [
                          _c(
                            "el-select",
                            {
                              class: _vm.importDifferenceField.containerLoadType
                                ? "red-border"
                                : "",
                              attrs: {
                                no: "containerLoadType",
                                disabled: !(_vm.isEdit && _vm.lclslaveEnabled)
                              },
                              on: {
                                change: function(val) {
                                  _vm.pm.containerLoadTypeChange(val)
                                }
                              },
                              model: {
                                value: _vm.form.containerLoadType,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "containerLoadType", $$v)
                                },
                                expression: "form.containerLoadType"
                              }
                            },
                            _vm._l(_vm.containerLoadTypes, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: _vm.isZh
                                    ? item.chineseName
                                    : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.CargoType") } },
                        [
                          _c(
                            "el-select",
                            {
                              class: _vm.importDifferenceField.cargoType
                                ? "red-border"
                                : "",
                              attrs: { filterable: "" },
                              on: {
                                change: function(val) {
                                  _vm.cargoTypeChange(val)
                                }
                              },
                              model: {
                                value: _vm.form.cargoType,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "cargoType", $$v)
                                },
                                expression: "form.cargoType"
                              }
                            },
                            _vm._l(_vm.cargoType4JobSelect, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: _vm.isZh
                                    ? item.chineseName
                                    : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.OrderChannels") } },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm.form.salesChannel,
                              disabled: true
                            }
                          })
                        ],
                        1
                      ),
                      _vm.showChannelNo
                        ? _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.ChannelNo") } },
                            [
                              _c("el-input", {
                                attrs: {
                                  value: _vm.form.channelNo,
                                  disabled: true
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.showChannelNo
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "SeaExport.ConsignationRelationNumber"
                                )
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  value: _vm.form.trustFromJob,
                                  disabled: true
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.BusinessCommissionedRelationNumber"
                            )
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm.form.relatedJob,
                              disabled: true
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.quotationNum") } },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm.form.quotationNo,
                              disabled: true
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.BookingDate") } },
                        [
                          _c("el-date-picker", {
                            class: _vm.importDifferenceField.bookingDate
                              ? "red-border"
                              : "",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "bookingDate",
                              disabled: _vm.readonly,
                              type: "date",
                              clearable: "",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.form.bookingDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "bookingDate", $$v)
                              },
                              expression: "form.bookingDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c("el-form-item", [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.DateOfDeparture2")))]
                        ),
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-date-picker", {
                              staticClass: "departure-date-picker",
                              class: _vm.importDifferenceField.etd
                                ? "red-border"
                                : "",
                              staticStyle: { flex: "1", "margin-right": "5px" },
                              attrs: {
                                no: "etd",
                                value: _vm.form.etd,
                                disabled:
                                  (_vm.form.lclMasterUuid
                                    ? true
                                    : !_vm.etdEnabled) ||
                                  _vm.canEditInternalDelegatedJobField ||
                                  !_vm.isJydEditJobFields ||
                                  _vm.provisionEtdLocked,
                                type: "date",
                                "value-format": "yyyy-MM-dd"
                              },
                              on: { input: _vm.etdChange }
                            }),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("filterWeek")(_vm.form.sailingDay)
                                )
                              )
                            ])
                          ],
                          1
                        ),
                        _vm.provisionEtdLocked
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "red",
                                  "font-size": "12px"
                                }
                              },
                              [_vm._v("(已计提校准不可修改)")]
                            )
                          : _vm._e()
                      ]),
                      _c("el-form-item", [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.DateOfArrival2")))]
                        ),
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-date-picker", {
                              class: _vm.importDifferenceField.eta
                                ? "red-border"
                                : "",
                              staticStyle: { flex: "1", "margin-right": "5px" },
                              attrs: {
                                no: "eta",
                                disabled:
                                  !_vm.lclslaveEnabled ||
                                  _vm.canEditInternalDelegatedJobField,
                                type: "date",
                                "value-format": "yyyy-MM-dd"
                              },
                              on: { input: _vm.etaChange },
                              model: {
                                value: _vm.form.eta,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "eta", $$v)
                                },
                                expression: "form.eta"
                              }
                            }),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("filterWeek")(_vm.form.etaSailingDay)
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ]),
                      _c("el-form-item", [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.ActualDateOfDeparture2"))
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { flex: "1", "margin-right": "5px" },
                              attrs: {
                                value: _vm.form.atd,
                                no: "atd",
                                disabled:
                                  !_vm.lclslaveEnabled ||
                                  _vm.canEditInternalDelegatedJobField,
                                type: "date",
                                "value-format": "yyyy-MM-dd"
                              },
                              on: { input: _vm.atdChange }
                            }),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("filterWeek")(_vm.form.atdSailingDay)
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ]),
                      _c("el-form-item", [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.ActualDateOfArrival2"))
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { flex: "1", "margin-right": "5px" },
                              attrs: {
                                no: "ata",
                                disabled:
                                  !_vm.lclslaveEnabled ||
                                  _vm.canEditInternalDelegatedJobField,
                                type: "date",
                                "value-format": "yyyy-MM-dd"
                              },
                              on: { input: _vm.ataChange },
                              model: {
                                value: _vm.form.ata,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "ata", $$v)
                                },
                                expression: "form.ata"
                              }
                            }),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("filterWeek")(_vm.form.ataSailingDay)
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.OperationDate") } },
                        [
                          _c("el-date-picker", {
                            class: _vm.importDifferenceField.customsDate
                              ? "red-border"
                              : "",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "customsDate",
                              type: "date",
                              disabled: !_vm.isJydUpdateCustomsDate,
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.form.customsDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "customsDate", $$v)
                              },
                              expression: "form.customsDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.PlaceOfReceiptCodeOnBl")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            class: _vm.importDifferenceField
                              .dispatchingPlaceCode
                              ? "red-border"
                              : "",
                            staticStyle: { flex: "1" },
                            attrs: {
                              no: "dispatchingPlaceCode",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              placeholder: _vm.$t("SeaExport.PlaceHolderPOR"),
                              filterable: "",
                              "default-value": _vm.form.dispatchingPlaceCode,
                              "tag-name": "englishName"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.changeDispatchingPlaceCode(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.PlaceOfReceiptOnBl")
                          }
                        },
                        [
                          _c("el-input", {
                            class: _vm.importDifferenceField.dispatchingPlace
                              ? "red-border"
                              : "",
                            attrs: { no: "dispatchingPlace" },
                            on: {
                              change: function($event) {
                                _vm.pm.cargoDocChangeHandler()
                                _vm.pm.changeDispatchingPlace()
                              }
                            },
                            model: {
                              value: _vm.form.dispatchingPlace,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "dispatchingPlace", $$v)
                              },
                              expression: "form.dispatchingPlace"
                            }
                          })
                        ],
                        1
                      ),
                      _c("el-form-item", [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.PortOfLoading")))]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              ref: "loadingPortCode",
                              class: _vm.importDifferenceField.loadingPortCode
                                ? "red-border"
                                : "",
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "loadingPortCode",
                                disabled: !_vm.lclslaveEnabled,
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Seaport,
                                filterable: "",
                                "default-value": _vm.form.loadingPortCode,
                                "tag-name": "englishName"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.pm.loadingPortCodeChange(p)
                                  _vm.pm.cargoDocChangeHandler()
                                  _vm.pm.changeLoadingPort()
                                  _vm.pm.setPlannerChange()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "padding-left": "2px" },
                                attrs: { no: "transfering" },
                                on: {
                                  change: function($event) {
                                    return _vm.pm.updateSecondVesselInfo()
                                  }
                                },
                                model: {
                                  value: _vm.form.transfering,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "transfering", $$v)
                                  },
                                  expression: "form.transfering"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Transit")))]
                            )
                          ],
                          1
                        )
                      ]),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.transfering,
                              expression: "form.transfering"
                            }
                          ],
                          attrs: { label: _vm.$t("SeaExport.TransitPort") }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "transferPortCode",
                              disabled: !_vm.lclslaveEnabled,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              filterable: "",
                              "default-value": _vm.form.transferPortCode
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.transferPortCode = p.value
                                _vm.pm.updateSecondVesselInfo()
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.PortOfDischarge"))
                              )
                            ]
                          ),
                          _c("cargo-advance-select", {
                            class: _vm.importDifferenceField.dischargingPortCode
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "dischargingPortCode",
                              disabled: !_vm.lclslaveEnabled,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              filterable: "",
                              "default-value": _vm.form.dischargingPortCode
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.dischargingPortCodeChange(
                                  p.value,
                                  _vm.form.carrierId
                                )
                                _vm.pm.cargoDocChangeHandler()
                                _vm.pm.changeDischargingPort()
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.PlaceOfDelivery"))
                              )
                            ]
                          ),
                          _c("cargo-advance-select", {
                            staticClass: "port-of-delivery-selector",
                            class: _vm.importDifferenceField.destinationPortCode
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "destinationPortCode",
                              "popper-class":
                                "port-of-delivery-selector-popper",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              filterable: "",
                              "default-value": _vm.form.destinationPortCode
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.destinationPortCodeChange(p)
                                _vm.pm.cargoDocChangeHandler()
                                _vm.pm.changeDestinationPort()
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_PlaceOfDeliveryRegion")
                                )
                              )
                            ]
                          ),
                          _c("cargo-advance-select", {
                            class: _vm.importDifferenceField
                              .placeOfDeliveryRegion
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "placeOfDeliveryRegion",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Region,
                              filterable: "",
                              "default-value": _vm.form.placeOfDeliveryRegion
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.placeOfDeliveryRegion = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.TransshipmentTransportationMethod"
                                  )
                                )
                              )
                            ]
                          ),
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "transportationMode",
                              "static-options": _vm.transportationModeInfos,
                              "filter-tag-names": [
                                "chineseName",
                                "englishName",
                                "code"
                              ],
                              filterable: "",
                              "tag-name": "englishName",
                              "default-value":
                                _vm.form.transshipmentTransportationModeCode
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.transshipmentTransportationModeCode =
                                  p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Airline") } },
                        [
                          _c("el-input", {
                            attrs: { value: _vm.pm.vesselLine, disabled: true }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.FinalDestination") }
                        },
                        [
                          _c("el-input", {
                            class: _vm.importDifferenceField.destinationPlace
                              ? "red-border"
                              : "",
                            attrs: { no: "destinationPlace" },
                            on: {
                              change: function($event) {
                                _vm.pm.cargoDocChangeHandler()
                                _vm.pm.changeDestinationPlace()
                              }
                            },
                            model: {
                              value: _vm.form.destinationPlace,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "destinationPlace", $$v)
                              },
                              expression: "form.destinationPlace"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.ShippingCompany") }
                        },
                        [
                          _c("cargo-company-select", {
                            ref: "shippingCompany",
                            class: _vm.importDifferenceField.carrierId
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "carrierId",
                              disabled: !_vm.carrierIdEnabled,
                              "method-params": {
                                companyLob: "seaExport",
                                seaCmp: true,
                                active: true
                              },
                              "default-value": _vm.form.carrierId || ""
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.carrierChangeHandler(
                                  _vm.form.dischargingPortCode,
                                  p.value
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm.bookingAgentVisible
                        ? _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("SeaExport.BookingAgent") }
                            },
                            [
                              !_vm.bookingAgentDataProviderChange
                                ? _c("cargo-advance-select", {
                                    class: _vm.importDifferenceField
                                      .bookingAgent
                                      ? "red-border"
                                      : "",
                                    attrs: {
                                      no: "bookingAgent",
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Company,
                                      filterable: "",
                                      disabled: !_vm.bookingAgentEnabled,
                                      "method-params": {
                                        bookingAgent: true,
                                        companyLob: "seaExport",
                                        active: true
                                      },
                                      "default-value":
                                        _vm.form.bookingAgent || ""
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.pm.bookingAgentChangeHandler(p)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm.bookingAgentDataProviderChange
                                ? _c("cargo-advance-select", {
                                    class: _vm.importDifferenceField
                                      .bookingAgent
                                      ? "red-border"
                                      : "",
                                    attrs: {
                                      no: "bookingAgent",
                                      cache: false,
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Company,
                                      disabled: !_vm.bookingAgentEnabled,
                                      "default-value":
                                        _vm.form.bookingAgent || "",
                                      "static-options": _vm.pm.bookingAgentArray
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.pm.bookingAgentChangeHandler()
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.CarrierAgent") } },
                        [
                          _c("cargo-company-select", {
                            class: _vm.importDifferenceField.carrierAgentId
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "carrierAgentId",
                              disabled: !_vm.lclslaveEnabled,
                              "method-params": {
                                seaCmpAgent: true,
                                companyLob: "seaExport",
                                active: true
                              },
                              "default-value": _vm.form.carrierAgentId || ""
                            },
                            on: {
                              change: function(p) {
                                _vm.form.carrierAgentId = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Message.TerminalCompany") } },
                        [
                          _c("cargo-company-select", {
                            class: _vm.importDifferenceField.terminalCompany
                              ? "red-border"
                              : "",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "terminalCompany",
                              "method-params": {
                                terminalCompany: true,
                                companyLob: "seaExport",
                                active: true
                              },
                              "default-value": _vm.form.terminalCompany || ""
                            },
                            on: {
                              change: function(p) {
                                _vm.JobUtils.terminalCompanyChangeHandler(
                                  _vm.form,
                                  p
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.SolicitationType") }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              class: _vm.importDifferenceField.cargoSource
                                ? "red-border"
                                : "",
                              attrs: {
                                no: "cargoSource",
                                disabled: !_vm.cargoSourceEnabled,
                                placeholder: _vm.$t("SeaExport.PleaseSelect"),
                                size: "mini"
                              },
                              on: {
                                change: function($event) {
                                  _vm.form.designationAgent = 0
                                  _vm.pm.cargoSourceChange({
                                    fieldName: "cargoSource"
                                  })
                                }
                              },
                              model: {
                                value: _vm.form.cargoSource,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "cargoSource", $$v)
                                },
                                expression: "form.cargoSource"
                              }
                            },
                            _vm._l(_vm.CARGO_SOURCES, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: _vm.isZh
                                    ? item.chineseName
                                    : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.CustomJobType") } },
                        [
                          _c("cargo-advance-select", {
                            ref: "customJobType",
                            class: _vm.importDifferenceField.customJobType
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "customJobType",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CutomJobType,
                              clearable: true,
                              filterable: "",
                              "default-value": _vm.form.customJobType,
                              "tag-name": _vm.isZh ? "name" : "englishName",
                              "static-options": _vm.customJobTypeList,
                              "method-params": { type: _vm.form.lob }
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.customJobType = p.value
                                _vm.onCustomJobTypeChange()
                                _vm.contractRuleFieldChange(
                                  _vm.form.customerId,
                                  _vm.form.designationAgent
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm.form.customJobType &&
                      _vm.secondaryCustomJobTypeList.length > 0
                        ? _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("CargoMsg.Cargo_Grade") }
                            },
                            [
                              _c("cargo-advance-select", {
                                ref: "secondaryCustomJobType",
                                attrs: {
                                  no: "secondaryCustomJobType",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_CutomJobType,
                                  filterable: "",
                                  cache: false,
                                  "default-value":
                                    _vm.form.secondaryCustomJobType,
                                  "tag-name": _vm.isZh ? "name" : "englishName",
                                  "static-options":
                                    _vm.secondaryCustomJobTypeList
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.secondaryCustomJobType = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.PortOfLoadingAgent")
                          }
                        },
                        [
                          _c("cargo-company-select", {
                            attrs: {
                              "method-params": {
                                localAgent: true,
                                active: true
                              },
                              no: "loadingAgentId",
                              disabled: _vm.readonly,
                              "default-value": _vm.form.loadingAgentId || "",
                              "data-filter-function":
                                _vm.JobUtils.loadingAgentIdFilter,
                              "tag-name": _vm.isZh
                                ? "chineseName"
                                : "englishName"
                            },
                            on: {
                              change: function(p) {
                                _vm.form.loadingAgentId = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("queryJob.destinationAgent") }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center"
                              }
                            },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.sopImageC,
                                      expression: "sopImageC"
                                    }
                                  ],
                                  attrs: {
                                    content: _vm.$t("SeaExport.SOPReceiver"),
                                    placement: "right-end"
                                  }
                                },
                                [
                                  _c("img", {
                                    staticClass: "sop-img",
                                    class:
                                      _vm.form.destinationAgent && _vm.readonly
                                        ? ""
                                        : "not-click",
                                    staticStyle: {
                                      padding: "5px 0",
                                      cursor: "pointer"
                                    },
                                    attrs: {
                                      src: _vm.sopPic,
                                      width: "18",
                                      height: "28"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.sopChangeHandler()
                                      }
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showWarningImageC,
                                      expression: "showWarningImageC"
                                    }
                                  ],
                                  attrs: {
                                    content: _vm.warningImageCTip,
                                    placement: "right-end"
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-warning red",
                                    staticStyle: { cursor: "pointer" }
                                  })
                                ]
                              ),
                              _c("cargo-advance-select", {
                                class: _vm.importDifferenceField
                                  .destinationAgent
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  no: "destinationAgent",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  disabled: !_vm.lclslaveEnabled,
                                  "method-params": {
                                    overseaAgent: true,
                                    companyLob: "seaExport",
                                    active: true
                                  },
                                  "default-value":
                                    _vm.form.destinationAgent || "",
                                  filterable: "",
                                  headers: [_vm.$t("Partners.englishName")],
                                  fields: ["englishName"],
                                  "tag-name": "englishName"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.pm.txtDestinationAgentChangeHandler(p)
                                  }
                                }
                              }),
                              _vm.overseaAgentDataProviderChange
                                ? _c("cargo-advance-select", {
                                    attrs: {
                                      no: "destinationAgent2",
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Company,
                                      cache: false,
                                      disabled: !_vm.lclslaveEnabled,
                                      "default-value":
                                        _vm.form.destinationAgent || "",
                                      filterable: "",
                                      "check-credit": true,
                                      headers: [_vm.$t("Partners.englishName")],
                                      fields: ["englishName"],
                                      "tag-name": "englishName",
                                      "static-options":
                                        _vm.pm.destinationAgentArray
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.pm.txtDestinationAgentChangeHandler(
                                          p
                                        )
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.cargoSource === "NC",
                              expression: "form.cargoSource==='NC'"
                            }
                          ]
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.NominatedAgent")))]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center"
                              }
                            },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.sopImageA,
                                      expression: "sopImageA"
                                    }
                                  ],
                                  attrs: {
                                    content: _vm.$t("SeaExport.SOPReceiver"),
                                    placement: "right-end"
                                  }
                                },
                                [
                                  _c("div", [
                                    _c("img", {
                                      staticClass: "sop-img",
                                      class:
                                        _vm.form.designationAgent &&
                                        _vm.readonly
                                          ? ""
                                          : "not-click",
                                      staticStyle: {
                                        padding: "5px 0",
                                        cursor: "pointer"
                                      },
                                      attrs: {
                                        src: _vm.sopPic,
                                        width: "18",
                                        height: "28"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.pm.sopChangeBookingAgentHandler()
                                        }
                                      }
                                    })
                                  ])
                                ]
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showWarningImageA,
                                      expression: "showWarningImageA"
                                    }
                                  ],
                                  attrs: {
                                    content: _vm.warningImageATip,
                                    placement: "right-end"
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-warning red",
                                    staticStyle: { cursor: "pointer" }
                                  })
                                ]
                              ),
                              _c("cargo-advance-select", {
                                staticClass: "designation-agent-selector",
                                attrs: {
                                  no: "designationAgent",
                                  "popper-class":
                                    "designation-agent-selector-popper",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  disabled: !_vm.designationAgentEnabled,
                                  "method-params": {
                                    designationAgent: true,
                                    active: true
                                  },
                                  "check-credit": true,
                                  "default-value":
                                    _vm.form.designationAgent || "",
                                  filterable: "",
                                  headers: [_vm.$t("Partners.englishName")],
                                  fields: ["englishName"],
                                  "tag-name": "englishName"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.pm.designationAgentChangeHandler(p)
                                  }
                                }
                              }),
                              _vm.overseaAgentDataProviderChange
                                ? _c("cargo-advance-select", {
                                    attrs: {
                                      no: "designationAgent2",
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Company,
                                      cache: false,
                                      disabled: !_vm.designationAgentEnabled,
                                      "check-credit": true,
                                      "default-value":
                                        _vm.form.designationAgent || "",
                                      filterable: "",
                                      headers: [_vm.$t("Partners.englishName")],
                                      fields: ["englishName"],
                                      "tag-name": "englishName",
                                      "static-options":
                                        _vm.pm.designationAgentArray
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.pm.designationAgentChangeHandler(p)
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.BillExchangeAgent")
                          }
                        },
                        [
                          _c("cargo-company-select", {
                            attrs: {
                              no: "exChangeAgent",
                              disabled: !_vm.form.destinationPortService,
                              "method-params": {
                                bookingAgent: true,
                                active: true
                              },
                              "default-value": _vm.form.exChangeAgent || ""
                            },
                            on: { change: _vm.onExChangeAgentChange }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_TransportSource")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_TransportSource,
                              no: "transportSource",
                              "default-value": _vm.form.transportSource,
                              cache: false,
                              "tag-value": "code",
                              placeholder: " "
                            },
                            on: {
                              parentCallBack: function(item) {
                                return (_vm.form.transportSource = item.value)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "CargoMsg.Cargo_ServiceStatisticalArea"
                            )
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_StatisticArea,
                              no: "statisticArea",
                              "default-value": _vm.form.statisticArea,
                              cache: false,
                              "tag-value": "code",
                              placeholder: " "
                            },
                            on: {
                              parentCallBack: function(item) {
                                return (_vm.form.statisticArea = item.value)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              ),
          _c(
            "div",
            {
              staticClass: "section form-column",
              staticStyle: { width: "400px" }
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "135px",
                    "label-position": "right"
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.AdditionalInformation")))
                  ]),
                  _vm.slaveCustomsDeclarationEnable
                    ? _c("customs-declaration", {
                        ref: "customsDeclaration",
                        attrs: {
                          no: "customsDeclaration",
                          job: _vm.form,
                          "is-editing": !_vm.readonly,
                          "del-po-items-uuids": _vm.delPoItemsUuids
                        },
                        on: {
                          quantityActualChange: _vm.quantityActualChange,
                          weightActualChange: _vm.weightActualChange,
                          cubageActualChange: _vm.cubageActualChange
                        }
                      })
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.LocalService") } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { display: "block" },
                          attrs: { no: "warehousing" },
                          on: {
                            change: function($event) {
                              return _vm.pm.loadingTermChange("warehousing")
                            }
                          },
                          model: {
                            value: _vm.form.warehousing,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "warehousing", $$v)
                            },
                            expression: "form.warehousing"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("SeaExport.WarehouseLoadingStorage")
                            ) + " "
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { display: "block" },
                          attrs: { no: "landTransportation" },
                          on: {
                            change: function($event) {
                              return _vm.pm.loadingTermChange(
                                "landTransportation"
                              )
                            }
                          },
                          model: {
                            value: _vm.form.landTransportation,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "landTransportation", $$v)
                            },
                            expression: "form.landTransportation"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.DoorLoadingDelivery")) +
                              " "
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { display: "block" },
                          attrs: { no: "selfDeliver" },
                          model: {
                            value: _vm.form.selfDeliver,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "selfDeliver", $$v)
                            },
                            expression: "form.selfDeliver"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "SeaExport.NotResponsibleForTruckingAndLoading"
                              )
                            ) + " "
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { display: "block" },
                          attrs: { no: "backUpWarehouse" },
                          on: {
                            change: function($event) {
                              return _vm.pm.backUpWarehouseChange()
                            }
                          },
                          model: {
                            value: _vm.form.backUpWarehouse,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "backUpWarehouse", $$v)
                            },
                            expression: "form.backUpWarehouse"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.BackUpWarehouse")) + " "
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "otherService" },
                          on: {
                            change: function($event) {
                              return _vm.pm.otherServiceChange()
                            }
                          },
                          model: {
                            value: _vm.form.otherService,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "otherService", $$v)
                            },
                            expression: "form.otherService"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Other")) + " ")]
                      ),
                      _c("el-input", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.form.otherService,
                            expression: "form.otherService"
                          }
                        ],
                        class: _vm.importDifferenceField.otherRemark
                          ? "red-border"
                          : "",
                        attrs: { no: "otherRemark", maxlength: "10" },
                        model: {
                          value: _vm.form.otherRemark,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "otherRemark", $$v)
                          },
                          expression: "form.otherRemark"
                        }
                      })
                    ],
                    1
                  ),
                  !_vm.isFba &&
                  _vm.isBookingNew &&
                  _vm.form.destinationPortService
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.PortOfDestinationServices")
                          }
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { display: "block" },
                              attrs: { no: "dischargingPortDoor" },
                              model: {
                                value: _vm.form.dischargingPortDoor,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "dischargingPortDoor", $$v)
                                },
                                expression: "form.dischargingPortDoor"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.DispatchVehiclesAtDestination"
                                  )
                                ) + " "
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { display: "block" },
                              attrs: { no: "usCustomsClearance" },
                              model: {
                                value: _vm.form.usCustomsClearance,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "usCustomsClearance", $$v)
                                },
                                expression: "form.usCustomsClearance"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("queryJob.UsCustomsClearance")) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { display: "block" },
                              attrs: { no: "destPortCustomsClearance" },
                              model: {
                                value: _vm.form.destPortCustomsClearance,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "destPortCustomsClearance",
                                    $$v
                                  )
                                },
                                expression: "form.destPortCustomsClearance"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.PortOfDestinationCustomsClearance"
                                  )
                                ) + " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isFba &&
                  _vm.isBookingNew &&
                  _vm.form.destinationPortService
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.PortOfDestinationServices")
                          }
                        },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              on: { change: _vm.addedServiceChangeHandler },
                              model: {
                                value: _vm.selectedPodAddedService,
                                callback: function($$v) {
                                  _vm.selectedPodAddedService = $$v
                                },
                                expression: "selectedPodAddedService"
                              }
                            },
                            _vm._l(_vm.podAddedService, function(item) {
                              return _c(
                                "el-checkbox",
                                {
                                  key: item.code,
                                  staticStyle: { display: "block" },
                                  attrs: { label: item.code },
                                  on: {
                                    change: function(val) {
                                      return _vm.singleAddedServiceChangeHandler(
                                        val,
                                        item
                                      )
                                    }
                                  }
                                },
                                [_vm._v(" " + _vm._s(item.chineseName) + " ")]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.jingyuWarehouse
                    ? _c(
                        "el-form-item",
                        {
                          class: _vm.warehouseNoRed ? "warehouseClass" : "",
                          attrs: { label: _vm.$t("SeaExport.WarehouseNo") }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { "margin-bottom": "10px" },
                            attrs: {
                              no: "warehouseNo",
                              disabled:
                                !_vm.pm.warehouseNoeditable || _vm.readonly
                            },
                            model: {
                              value: _vm.form.warehouseNo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "warehouseNo", $$v)
                              },
                              expression: "form.warehouseNo"
                            }
                          }),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                "padding-left": "13px",
                                "padding-right": "13px"
                              },
                              attrs: {
                                disabled: !(_vm.isEdit && _vm.isHbl),
                                no: "ObtainTheWarehouseNo",
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.pm.clickWarehouseNoHandler()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SeaExport.ObtainTheWarehouseNo")
                                ) + " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.jingyuWarehouse
                    ? _c(
                        "el-form-item",
                        {
                          class: _vm.warehouseNoRed ? "warehouseClass" : "",
                          attrs: { label: _vm.$t("SeaExport.WarehouseNo") }
                        },
                        [
                          _c("warehouse-no-input", {
                            staticStyle: { "margin-bottom": "10px" },
                            attrs: {
                              "job-warehouse-nos": _vm.jobWarehouseNos,
                              job: _vm.form,
                              no: "warehouseNo2",
                              disabled:
                                !_vm.pm.warehouseNoeditable || _vm.readonly
                            },
                            on: {
                              "update:jobWarehouseNos": function($event) {
                                _vm.jobWarehouseNos = $event
                              },
                              "update:job-warehouse-nos": function($event) {
                                _vm.jobWarehouseNos = $event
                              }
                            },
                            model: {
                              value: _vm.form.warehouseNo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "warehouseNo", $$v)
                              },
                              expression: "form.warehouseNo"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Warehouse.WarehouseInState"),
                        no: "WarehouseState"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            disabled: true,
                            placeholder: _vm.$t("Message.PleaseSelect"),
                            size: "mini"
                          },
                          model: {
                            value: _vm.form.warehouseStatus,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "warehouseStatus", $$v)
                            },
                            expression: "form.warehouseStatus"
                          }
                        },
                        _vm._l(_vm.WarehouseInState.WAREHOUSE_STATE, function(
                          item,
                          index
                        ) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label:
                                _vm.$store.getters.language === "zh"
                                  ? item.chineseName
                                  : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.MasterBusinessNo") } },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: true,
                          value: _vm.form.lclMaster
                            ? _vm.form.lclMaster.jobNo
                            : ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      class: _vm.customerRefNoRed ? "warehouseClass" : "",
                      attrs: {
                        id: "customerRefNo",
                        label: _vm.$t("SeaExport.BusinessReferenceNo")
                      }
                    },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            disabled: !_vm.customerRefNoTip,
                            content: _vm.customerRefNoTip,
                            placement: "right-end"
                          }
                        },
                        [
                          _c("el-input", {
                            class: _vm.customerRefNoTip ? "red" : "",
                            attrs: { no: "customerRefNo" },
                            on: {
                              blur: function($event) {
                                return _vm.pm.customerRefNoFocusOutHandler()
                              }
                            },
                            model: {
                              value: _vm.form.customerRefNo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "customerRefNo", $$v)
                              },
                              expression: "form.customerRefNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.form.cargoSource === "NC"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            id: "agentRefNo",
                            label: _vm.$t("SeaExport.NCReferenceNo")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "agentRefNo" },
                            model: {
                              value: _vm.form.agentRefNo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "agentRefNo", $$v)
                              },
                              expression: "form.agentRefNo"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      class: _vm.poNoRed ? "warehouseClass" : "",
                      attrs: { label: _vm.$t("SeaExport.ItemNo") }
                    },
                    [
                      !_vm.openProjectConfig
                        ? _c("el-input", {
                            attrs: { no: "poNo" },
                            model: {
                              value: _vm.form.poNo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "poNo", $$v)
                              },
                              expression: "form.poNo"
                            }
                          })
                        : _vm._e(),
                      _vm.openProjectConfig
                        ? _c("cargo-project-select", {
                            attrs: {
                              no: "poNo",
                              "default-value": _vm.form.poNo,
                              "customer-id": _vm.form.customerId,
                              "is-linked": _vm.isProjectLinkedCustomer
                            },
                            on: {
                              change: function(p) {
                                _vm.form.poNo = p.value
                                _vm.form.projectName = p.projectName
                                _vm.changeProject()
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.openProjectConfig
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.ProjectName") } },
                        [
                          _c("el-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.projectName,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "projectName", $$v)
                              },
                              expression: "form.projectName"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.openProjectConfig
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.ProjectBatch") } },
                        [
                          _c("el-input", {
                            attrs: { no: "projectBatch" },
                            model: {
                              value: _vm.form.projectBatch,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "projectBatch", $$v)
                              },
                              expression: "form.projectBatch"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomsBroker") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "customsBroker",
                          disabled: !_vm.customsBrokerEnabled,
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "data-filter-function": _vm.customsBrokerFilter,
                          filterable: "",
                          "default-value": _vm.form.customsBroker || "",
                          placeholder: !_vm.customsBrokerEnabled
                            ? _vm.$t(
                                "SeaExport.PleaseTickCustomsDeclarationOption"
                              )
                            : _vm.$t("CargoMsg.Cargo_keyWordsTip"),
                          "method-params": {
                            customsBroker: true,
                            companyLob: "seaExport",
                            active: true
                          }
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.customsBrokerChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  !_vm.isFba
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.CustomsDeclarationMethod")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "customsMethod",
                              disabled: !_vm.customsBrokerEnabled,
                              "select-type":
                                _vm.selectTypeNames.basic_data_CustomsMode,
                              "method-params": { serviceType: 2 },
                              "tag-value": "serialNum",
                              filterable: "",
                              "default-value": _vm.form.customClaim
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.customClaim = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.CustomsDeclarationType")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "customsDeclarationType",
                          disabled: !_vm.customsBrokerEnabled,
                          "select-type":
                            _vm.selectTypeNames
                              .basic_data_CustomsDeclarationType,
                          filterable: "",
                          "default-value":
                            _vm.form.customsDeclarationType === -1
                              ? ""
                              : _vm.form.customsDeclarationType,
                          placeholder: _vm.$t("CargoMsg.Cargo_keyWordsTip")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.customsDeclarationType = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.TradeMethod") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "tradeTerm",
                          "select-type":
                            _vm.selectTypeNames.basic_data_TradeTerm,
                          filterable: "",
                          "default-value": _vm.form.tradeTerm
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.tradeTerm = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.HaulageCompany") } },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          no: "carryingCmp",
                          disabled: !_vm.form.landTransportation,
                          "method-params": { truckCmp: true, active: true },
                          "default-value": _vm.form.carryingCmp || "",
                          placeholder: !_vm.form.landTransportation
                            ? _vm.$t(
                                "SeaExport.PleaseTickDoorLoadingDeliveryOption"
                              )
                            : _vm.$t("CargoMsg.Cargo_keyWordsTip")
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.carryingCmpChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.isFba
                          ? _vm.$t("SeaExport.DomesticWarehouse")
                          : _vm.openWarehouse
                          ? _vm.$t("SeaExport.WarehouseSupplier")
                          : _vm.$t("SeaExport.Warehouse")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          no: "warehouseCmp",
                          disabled: !_vm.warehouseEabled,
                          "method-params": { warehouse: true, active: true },
                          "default-value": _vm.isFba
                            ? Number(_vm.fbaJob.domesticWarehouse) || ""
                            : _vm.form.warehouseCmp || "",
                          placeholder: !_vm.warehouseEabled
                            ? _vm.$t("SeaExport.PleaseSelectWarehouse")
                            : _vm.$t("CargoMsg.Cargo_keyWordsTip")
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.warehouseCmpChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.openWarehouse
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.WareHouseName") } },
                        [
                          _c(
                            "el-select",
                            {
                              ref: "warehouseName",
                              attrs: {
                                no: "warehouseName",
                                disabled:
                                  !_vm.warehouseEabled ||
                                  !_vm.form.warehouseCmp,
                                "allow-create": true,
                                filterable: "",
                                clearable: true
                              },
                              on: { change: _vm.warehouseNameChangeHandler },
                              model: {
                                value: _vm.form.warehouseName,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "warehouseName", $$v)
                                },
                                expression: "form.warehouseName"
                              }
                            },
                            _vm._l(_vm.warehouseNameList, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.warehouseName,
                                  value: item.warehouseName
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.BackUpWarehouse") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "backUpWarehouseCmp",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          cache: false,
                          disabled: !_vm.backUpWarehouseEnabled,
                          "default-value": _vm.form.backUpWarehouseCmp || "",
                          filterable: "",
                          "static-options": _vm.backUpWarehouseCompanyList,
                          placeholder: !_vm.backUpWarehouseEnabled
                            ? _vm.$t("SeaExport.PleaseSelectBackUpWarehouse")
                            : _vm.$t("CargoMsg.Cargo_keyWordsTip")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.backUpWarehouseCmpChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.isFba
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.ForeignWarehouse") }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "overseaWarehouseCode",
                              "select-type":
                                _vm.selectTypeNames.basic_data_OverseaWarehouse,
                              filterable: "",
                              "method-params": { ifFba: false },
                              clearable: false,
                              "tag-name": "countryChineseName",
                              "tag-value": "warehouseCode",
                              "default-value": _vm.form.overseaWarehouseCode
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.overseaWarehouseCode = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.MBLTransportationClause")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.freightTerm
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "freightTerm",
                          "select-type":
                            _vm.selectTypeNames.basic_data_ShippingTerm,
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.form.freightTerm
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.freightTerm = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.form.mblOnly,
                          expression: "!form.mblOnly"
                        }
                      ],
                      attrs: {
                        label: _vm.$t("SeaExport.HBLTransportationClause")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.freightTermHBL
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "freightTermHBL",
                          "select-type":
                            _vm.selectTypeNames.basic_data_ShippingTerm,
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.form.freightTermHBL
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.freightTermHBL = p.value
                            _vm.pm.freightTermHBLChange()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.MasterBLFreightTerm") }
                    },
                    [
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.paymentTermMBL
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "paymentTermMBL",
                          disabled: !_vm.lclslaveEnabled,
                          "select-type":
                            _vm.selectTypeNames.basic_data_PaymentTerm,
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.form.paymentTermMBL
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.paymentTermMBL = p.value
                            _vm.pm.paymentTermMBLChange()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.PlaceOfMblPayment") } },
                    [
                      _c("el-input", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.pm.isShowAcPaymentPlaceBL,
                            expression: "!pm.isShowAcPaymentPlaceBL"
                          }
                        ],
                        attrs: {
                          no: "paymentPlaceBL",
                          disabled: !(
                            _vm.isEdit &&
                            (_vm.form.paymentTermMBL === "3P" ||
                              _vm.form.paymentTermMBL === "PP")
                          )
                        },
                        on: {
                          change: function($event) {
                            return _vm.pm.fieldChangeHandler()
                          }
                        },
                        model: {
                          value: _vm.mblDoc.paymentPlaceBL,
                          callback: function($$v) {
                            _vm.$set(_vm.mblDoc, "paymentPlaceBL", $$v)
                          },
                          expression: "mblDoc.paymentPlaceBL"
                        }
                      }),
                      _vm.pm.isShowAcPaymentPlaceBL
                        ? _c("cargo-advance-select", {
                            attrs: {
                              no: "paymentPlaceBL",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              filterable: "",
                              "default-value": _vm.mblDoc.paymentPlaceBL || ""
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.mblDoc.paymentPlaceBL = p.value
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.form.mblOnly,
                          expression: "!form.mblOnly"
                        }
                      ],
                      attrs: { label: _vm.$t("SeaExport.HBLFreightClause") }
                    },
                    [
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.paymentTermHBL
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "paymentTermHBL",
                          "select-type":
                            _vm.selectTypeNames.basic_data_PaymentTerm,
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.form.paymentTermHBL,
                          "allow-create": true
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.paymentSelectHblChange(p.value)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.form.mblOnly,
                          expression: "!form.mblOnly"
                        }
                      ],
                      attrs: { label: _vm.$t("SeaExport.PlaceOfHblPayment") }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "paymentPlaceBL" },
                        model: {
                          value: _vm.hdoc.paymentPlaceBL,
                          callback: function($$v) {
                            _vm.$set(_vm.hdoc, "paymentPlaceBL", $$v)
                          },
                          expression: "hdoc.paymentPlaceBL"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.ContractRateProperty") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          class: _vm.importDifferenceField.bookingTerm
                            ? "red-border"
                            : "",
                          attrs: {
                            no: "bookingTerm",
                            disabled: !_vm.pm.bookingTermEditable,
                            placeholder: !_vm.pm.bookingTermEditable
                              ? ""
                              : _vm.$t("SeaExport.PleaseSelect"),
                            clearable: false,
                            size: "mini"
                          },
                          model: {
                            value: _vm.form.bookingTerm,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "bookingTerm", $$v)
                            },
                            expression: "form.bookingTerm"
                          }
                        },
                        _vm._l(_vm.bookingTerms, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.TradeTerms2") } },
                    [
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.incoTerm
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "incoTerm",
                          "select-type":
                            _vm.selectTypeNames.basic_data_IncoTerm,
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.form.incoTerm
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.incoTerm = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CargoSize") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "measurements",
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.CargoSize"),
                              _vm.form.measurements,
                              function(val) {
                                _vm.form.measurements = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.measurements,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "measurements", $$v)
                          },
                          expression: "form.measurements"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.SpecialPriceInstructions")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "salePriceRemarks" },
                        model: {
                          value: _vm.form.salePriceRemarks,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "salePriceRemarks", $$v)
                          },
                          expression: "form.salePriceRemarks"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-around"
                      }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { margin: "0" },
                          attrs: { no: "mblOnly" },
                          on: {
                            change: function($event) {
                              return _vm.pm.isMblOnlyChange()
                            }
                          },
                          model: {
                            value: _vm.form.mblOnly,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "mblOnly", $$v)
                            },
                            expression: "form.mblOnly"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.DirectBusiness")) + " "
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { margin: "0" },
                          attrs: {
                            no: "transfering",
                            disabled: !_vm.lclslaveEnabled
                          },
                          model: {
                            value: _vm.form.transfering,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "transfering", $$v)
                            },
                            expression: "form.transfering"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Transport")) + " ")]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { margin: "0" },
                          attrs: {
                            no: "batch",
                            disabled: !_vm.lclslaveEnabled
                          },
                          model: {
                            value: _vm.form.batch,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "batch", $$v)
                            },
                            expression: "form.batch"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.InBatches")) + " ")]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { margin: "0" },
                          attrs: { no: "salePrice" },
                          model: {
                            value: _vm.form.salePrice,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "salePrice", $$v)
                            },
                            expression: "form.salePrice"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.SpecialPrice")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { margin: "0" },
                          attrs: { no: "allocation" },
                          model: {
                            value: _vm.form.allocation,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "allocation", $$v)
                            },
                            expression: "form.allocation"
                          }
                        },
                        [_vm._v(_vm._s("Alloc") + " ")]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "availableCabinSpace" },
                          model: {
                            value: _vm.form.availableCabinSpace,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "availableCabinSpace", $$v)
                            },
                            expression: "form.availableCabinSpace"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("CargoMsg.Cargo_AvailableCabinSpace")
                            ) + " "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.FreeDemurrage") } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: { controls: false, no: "freeDemurrage" },
                        model: {
                          value: _vm.form.freeDemurrage,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "freeDemurrage", $$v)
                          },
                          expression: "form.freeDemurrage"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.FreeDetention") } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: { controls: false, no: "freeDetention" },
                        model: {
                          value: _vm.form.freeDetention,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "freeDetention", $$v)
                          },
                          expression: "form.freeDetention"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.CustomsAreaApplication")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "customsAreaApplication" },
                        model: {
                          value: _vm.form.customsAreaApplication,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "customsAreaApplication", $$v)
                          },
                          expression: "form.customsAreaApplication"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_BoxOneWay") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "boxOneWay" },
                          model: {
                            value: _vm.form.boxOneWay,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "boxOneWay", $$v)
                            },
                            expression: "form.boxOneWay"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_PleaseSelectP"),
                              value: 0
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_OneWay"),
                              value: 1
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_Circulation"),
                              value: 2
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "section form-column",
              style: _vm.$selectByLang(
                "width: 330px",
                "width: 330px",
                "width: 340px"
              )
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": _vm.$selectByLang("120px", "120px", "130px"),
                    "label-position": "right"
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.ContainerInfo2")))
                  ]),
                  _vm.form.containerLoadType === "FCL" ||
                  _vm.form.containerLoadType === "BB" ||
                  _vm.form.containerLoadType === "BCF"
                    ? _c("booking-sea-eq-data-grid", {
                        ref: "bookingSeaEqDataGrid",
                        attrs: {
                          no: "bookingSeaEqDataGrid",
                          value: _vm.seaEqList,
                          "container-load-type": _vm.form.containerLoadType,
                          "is-edit": _vm.isEdit,
                          job: _vm.form,
                          "slave-customs-declaration-enable":
                            _vm.slaveCustomsDeclarationEnable
                        },
                        on: { eqQuantityChange: _vm.eqQuantityChangeHandler }
                      })
                    : _vm._e(),
                  _vm.form.containerLoadType === "BULK"
                    ? _c("booking-bulk-data-grid", {
                        attrs: {
                          no: "BULK",
                          value: _vm.cargoBulkDetailList,
                          context: _vm.context,
                          "job-uuid": _vm.form.uuid,
                          "is-edit": _vm.isEdit
                        }
                      })
                    : _vm._e(),
                  _vm.form.containerLoadType === "SPA"
                    ? _c("booking-special-data-grid", {
                        attrs: {
                          no: "SPA",
                          value: _vm.seaEqList,
                          "is-edit": _vm.isEdit,
                          job: _vm.form
                        },
                        on: { eqQuantityChange: _vm.eqQuantityChangeHandler }
                      })
                    : _vm._e(),
                  _vm.showCharacteristic
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-around"
                          }
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { margin: "0" },
                              attrs: { no: "electric" },
                              model: {
                                value: _vm.form.electric,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "electric", $$v)
                                },
                                expression: "form.electric"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Electric")) + " ")]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { margin: "0" },
                              attrs: { no: "magnetic" },
                              model: {
                                value: _vm.form.magnetic,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "magnetic", $$v)
                                },
                                expression: "form.magnetic"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Magnetic")) + " ")]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { margin: "0" },
                              attrs: { no: "powder" },
                              model: {
                                value: _vm.form.powder,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "powder", $$v)
                                },
                                expression: "form.powder"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Powder")) + " ")]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: { no: "liquid" },
                              model: {
                                value: _vm.form.liquid,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "liquid", $$v)
                                },
                                expression: "form.liquid"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Liquid")))]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.QuantityConsignActual")
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("auto-number-input", {
                            class: _vm.importDifferenceField.quantityContract
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "quantityContract",
                              precision: 0,
                              min: 0,
                              disabled: !_vm.isJydEditJobFields
                            },
                            on: {
                              change: function($event) {
                                _vm.pm.jobContractQwcChange(1)
                                _vm.calcEstVolumetricAndChargeWeight()
                              }
                            },
                            model: {
                              value: _vm.form.quantityContract,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "quantityContract", $$v)
                              },
                              expression: "form.quantityContract"
                            }
                          }),
                          _c("span", { staticStyle: { padding: "0 2px" } }, [
                            _vm._v("/")
                          ]),
                          _c("auto-number-input", {
                            ref: "quantityActual",
                            class: _vm.importDifferenceField.quantityActual
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "quantityActual",
                              precision: 0,
                              disabled:
                                _vm.pm.billChargeFlag ||
                                !_vm.isJydEditJobFields,
                              min: 0
                            },
                            on: {
                              change: function($event) {
                                _vm.quantityActualChange()
                                _vm.pm.syncQwcToPoItems(
                                  _vm.form.quantityActual || 0,
                                  null,
                                  null
                                )
                              }
                            },
                            model: {
                              value: _vm.form.quantityActual,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "quantityActual", $$v)
                              },
                              expression: "form.quantityActual"
                            }
                          }),
                          _c("span", [_vm._v("PCS")])
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.WeightConsignActual") }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("auto-number-input", {
                            class: _vm.importDifferenceField.weightContract
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "weightContract",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.isJydEditJobFields
                            },
                            on: {
                              change: function($event) {
                                _vm.weightContractChange()
                                _vm.calcEstVolumetricAndChargeWeight()
                              }
                            },
                            model: {
                              value: _vm.form.weightContract,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "weightContract", $$v)
                              },
                              expression: "form.weightContract"
                            }
                          }),
                          _c("span", { staticStyle: { padding: "0 2px" } }, [
                            _vm._v("/")
                          ]),
                          _c("auto-number-input", {
                            ref: "weightActual",
                            class: _vm.importDifferenceField.weightActual
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "weightActual",
                              precision: 3,
                              disabled:
                                _vm.pm.billChargeFlag ||
                                !_vm.isJydEditJobFields,
                              min: 0
                            },
                            on: {
                              change: function($event) {
                                _vm.weightActualChange()
                                _vm.pm.syncQwcToPoItems(
                                  null,
                                  _vm.form.weightActual || 0,
                                  null
                                )
                              }
                            },
                            model: {
                              value: _vm.form.weightActual,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "weightActual", $$v)
                              },
                              expression: "form.weightActual"
                            }
                          }),
                          _c("span", [_vm._v("KGS")])
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.CubageConsignActual") }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("auto-number-input", {
                            class: _vm.importDifferenceField.cubageContract
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "cubageContract",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.isJydEditJobFields
                            },
                            on: {
                              change: function($event) {
                                _vm.cubageContractChange()
                                _vm.calcEstVolumetricAndChargeWeight()
                              }
                            },
                            model: {
                              value: _vm.form.cubageContract,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cubageContract", $$v)
                              },
                              expression: "form.cubageContract"
                            }
                          }),
                          _c("span", { staticStyle: { padding: "0 2px" } }, [
                            _vm._v("/")
                          ]),
                          _c("auto-number-input", {
                            ref: "cubageActual",
                            class: _vm.importDifferenceField.cubageActual
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "cubageActual",
                              precision: 3,
                              disabled:
                                !_vm.cubageActualEnabled ||
                                !_vm.isJydEditJobFields,
                              min: 0
                            },
                            on: {
                              change: function($event) {
                                _vm.cubageActualChange()
                                _vm.pm.syncQwcToPoItems(
                                  null,
                                  null,
                                  _vm.form.cubageActual || 0
                                )
                              }
                            },
                            model: {
                              value: _vm.form.cubageActual,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cubageActual", $$v)
                              },
                              expression: "form.cubageActual"
                            }
                          }),
                          _c("span", [_vm._v("CBM")])
                        ],
                        1
                      )
                    ]
                  ),
                  _vm.isFba
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.VolumetricWeightConsignActual"
                            )
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("auto-number-input", {
                                attrs: {
                                  no: "volumetricWeightContract",
                                  precision: 3,
                                  min: 0
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.calcEstVolumetricAndChargeWeight(
                                      _vm.form.volumetricWeightContract
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.volumetricWeightContract,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "volumetricWeightContract",
                                      $$v
                                    )
                                  },
                                  expression: "form.volumetricWeightContract"
                                }
                              }),
                              _c(
                                "span",
                                { staticStyle: { padding: "0 2px" } },
                                [_vm._v("/")]
                              ),
                              _c("auto-number-input", {
                                ref: "volumetricWeight",
                                attrs: {
                                  no: "volumetricWeight",
                                  precision: 3,
                                  min: 0
                                },
                                on: { change: _vm.changeVolumetricWeight },
                                model: {
                                  value: _vm.form.volumetricWeight,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "volumetricWeight", $$v)
                                  },
                                  expression: "form.volumetricWeight"
                                }
                              }),
                              _c("span", [_vm._v("KGS")])
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.isFba
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.ChargeWeightConsignActual")
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("auto-number-input", {
                                attrs: {
                                  no: "chargeWeightContract",
                                  precision: 3,
                                  min: 0
                                },
                                model: {
                                  value: _vm.form.chargeWeightContract,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "chargeWeightContract",
                                      $$v
                                    )
                                  },
                                  expression: "form.chargeWeightContract"
                                }
                              }),
                              _c(
                                "span",
                                { staticStyle: { padding: "0 2px" } },
                                [_vm._v("/")]
                              ),
                              _c("auto-number-input", {
                                ref: "chargeWeight",
                                attrs: {
                                  no: "chargeWeight",
                                  precision: 3,
                                  min: 0
                                },
                                on: { change: _vm.changeChargeWeight },
                                model: {
                                  value: _vm.form.chargeWeight,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "chargeWeight", $$v)
                                  },
                                  expression: "form.chargeWeight"
                                }
                              }),
                              _c("span", [_vm._v("KGS")])
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.isFba
                    ? _c("el-form-item", { attrs: { "label-width": "0" } }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-around"
                            }
                          },
                          [
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: {
                                  "margin-right": "10px",
                                  "margin-left": "20px"
                                },
                                model: {
                                  value: _vm.fbaJob.electric,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "electric", $$v)
                                  },
                                  expression: "fbaJob.electric"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.WithElectricity"))
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-right": "10px" },
                                model: {
                                  value: _vm.fbaJob.magnetic,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "magnetic", $$v)
                                  },
                                  expression: "fbaJob.magnetic"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.WithMagnetism"))
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-right": "10px" },
                                model: {
                                  value: _vm.fbaJob.powdery,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "powdery", $$v)
                                  },
                                  expression: "fbaJob.powdery"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Powder")))]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-right": "10px" },
                                model: {
                                  value: _vm.fbaJob.liquid,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "liquid", $$v)
                                  },
                                  expression: "fbaJob.liquid"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Liquid")))]
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.containerLoadType === "BULK",
                          expression: "form.containerLoadType==='BULK'"
                        }
                      ],
                      attrs: { label: _vm.$t("SeaExport.QuantitySize") }
                    },
                    [
                      _c("auto-number-input", {
                        staticStyle: { width: "100%" },
                        attrs: { no: "insideQuantitySize", precision: 0 },
                        model: {
                          value: _vm.form.insideQuantitySize,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "insideQuantitySize", $$v)
                          },
                          expression: "form.insideQuantitySize"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Package") } },
                    [
                      _c("cargo-packing-select", {
                        class: _vm.importDifferenceField.packing
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "packing",
                          "default-value": _vm.form.packing
                        },
                        on: {
                          change: function(p) {
                            _vm.form.packing = p.value
                            _vm.pm.txtPackingChangeHandler()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Pieces") } },
                    [
                      _c("auto-number-input", {
                        class: _vm.importDifferenceField.insideQuantity
                          ? "red-border"
                          : "",
                        attrs: { no: "insideQuantity", precision: 0, min: 0 },
                        on: {
                          valCallBack: function(val) {
                            _vm.form.insideQuantity = val
                          }
                        },
                        model: {
                          value: _vm.form.insideQuantity,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "insideQuantity", $$v)
                          },
                          expression: "form.insideQuantity"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.PiecesType") } },
                    [
                      _c("cargo-packing-select", {
                        attrs: {
                          no: "insidePacking",
                          "default-value": _vm.form.insidePacking
                        },
                        on: {
                          change: function(p) {
                            _vm.form.insidePacking = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  !_vm.isFba
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.ChargedWeightRT") }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("auto-number-input", {
                                class: _vm.importDifferenceField.chargeWeight
                                  ? "red-border"
                                  : "",
                                staticStyle: { flex: "1" },
                                attrs: {
                                  no: "chargeWeight",
                                  precision: 3,
                                  disabled: !_vm.chargeWeightEnabled,
                                  min: 0
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.pm.chargeWeightChange()
                                  }
                                },
                                model: {
                                  value: _vm.form.chargeWeight,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "chargeWeight", $$v)
                                  },
                                  expression: "form.chargeWeight"
                                }
                              }),
                              _c("span", [_vm._v("M/T")])
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit,
                          expression: "isEdit"
                        }
                      ]
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "label" }, slot: "label" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { no: "Copy2", type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.transcribeDialog.visible = true
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Copy2")) + " ")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _vm.toExoSystemJYD
                ? _c(
                    "el-form",
                    {
                      attrs: {
                        disabled: _vm.lockJobByPrintHblZb
                          ? false
                          : _vm.readonly,
                        "label-width": _vm.$selectByLang(
                          "120px",
                          "120px",
                          "130px"
                        ),
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Remarks") } },
                        [
                          _c("el-input", {
                            attrs: { no: "remarks", type: "textarea", rows: 4 },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.Remarks"),
                                  _vm.form.remarks,
                                  function(val) {
                                    _vm.form.remarks = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.remarks,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "remarks", $$v)
                              },
                              expression: "form.remarks"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.OperationRequirements")
                          }
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: _vm.form.operationContent,
                                placement: "left"
                              }
                            },
                            [
                              _c("div", {
                                attrs: { slot: "content" },
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.form.operationContent
                                      ? _vm.form.operationContent.replace(
                                          /[\n]/g,
                                          "</br>"
                                        )
                                      : _vm.$t("SeaExport.NoData")
                                  )
                                },
                                slot: "content"
                              }),
                              _c("el-input", {
                                attrs: {
                                  no: "operationContent",
                                  value: _vm.form.operationContent,
                                  placeholder: _vm.readonly
                                    ? ""
                                    : _vm.$t(
                                        "SeaExport.DoubleClickToAddOperationRequirements"
                                      ),
                                  type: "textarea",
                                  rows: 4
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    _vm.selectOperationReqDialog.value =
                                      _vm.form.operationContent
                                    _vm.selectOperationReqDialog.visible =
                                      _vm.isEdit || _vm.lockJobByPrintHblZb
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.OperationTips") } },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "operationTips",
                              type: "textarea",
                              rows: 4
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.OperationTips"),
                                  _vm.form.operationTips,
                                  function(val) {
                                    _vm.form.operationTips = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.operationTips,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "operationTips", $$v)
                              },
                              expression: "form.operationTips"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": _vm.$selectByLang("120px", "120px", "130px"),
                    "label-position": "right"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.EnglishDescriptionOfGoods")
                      }
                    },
                    [
                      _c(
                        "special-character-tip",
                        {
                          attrs: {
                            texts: _vm.specialCharCheck.cargoEnglishName
                          }
                        },
                        [
                          _c("cargo-rich-textarea", {
                            ref: "cargoTextarea1",
                            class:
                              _vm.importDifferenceField.cargoEnglishName ||
                              _vm.form.cargoEnglishNameWarning === 1
                                ? "red-border"
                                : "",
                            staticStyle: { height: "110px" },
                            attrs: {
                              no: "cargoEnglishName",
                              "show-count": true,
                              "text-chars": 0,
                              "warning-count": -1,
                              disabled: !_vm.isEdit,
                              "wrap-symbol": "r",
                              "auto-half-word": "",
                              "auto-uppercase": _vm.isUppercaseByConfig
                            },
                            on: { change: _vm.onCargoEnglishNameChange },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.EnglishDescriptionOfGoods"),
                                  _vm.form.cargoEnglishName,
                                  function(val) {
                                    _vm.pm.cargoEnglishNameChangeHandler(val)
                                  },
                                  _vm.isUppercaseByConfig,
                                  {
                                    autoHalfWord: true,
                                    autoUppercase: _vm.isUppercaseByConfig
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.cargoEnglishName,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cargoEnglishName", $$v)
                              },
                              expression: "form.cargoEnglishName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Marks") } },
                    [
                      _c(
                        "special-character-tip",
                        { attrs: { texts: _vm.specialCharCheck.mark } },
                        [
                          _c("cargo-rich-textarea", {
                            ref: "cargoTextarea2",
                            class: _vm.importDifferenceField.mark
                              ? "red-border"
                              : "",
                            staticStyle: { height: "110px" },
                            attrs: {
                              no: "mark",
                              "show-count": true,
                              "text-chars": 0,
                              "warning-count": -1,
                              "wrap-symbol": "r",
                              "auto-half-word": "",
                              "auto-uppercase": _vm.isUppercaseByConfig,
                              disabled: !_vm.isEdit
                            },
                            on: { change: _vm.onMarkChange },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.Marks"),
                                  _vm.form.mark,
                                  function(val) {
                                    _vm.pm.markChangeHandler(val)
                                  },
                                  _vm.isUppercaseByConfig,
                                  {
                                    autoHalfWord: true,
                                    autoUppercase: _vm.isUppercaseByConfig
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.mark,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "mark", $$v)
                              },
                              expression: "form.mark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        { attrs: { slot: "label" }, slot: "label" },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("SeaExport.HsCode")))
                          ]),
                          _c("br"),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isEdit,
                                  expression: "isEdit"
                                }
                              ],
                              attrs: { no: "Search", type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.showHsCodeSearchDialog(
                                    _vm.$t("Message.SelectHsCode"),
                                    function(val) {
                                      _vm.pm.hsCodeChangeHandler(val.code)
                                    }
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Search")) + " ")]
                          )
                        ],
                        1
                      ),
                      _c("el-input", {
                        class: _vm.importDifferenceField.hsCode
                          ? "red-border"
                          : "",
                        attrs: { no: "hsCode", type: "textarea", rows: 5 },
                        on: {
                          change: function(val) {
                            _vm.pm.hsCodeChangeHandler(val)
                          }
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.HsCode"),
                              _vm.form.hsCode,
                              function(val) {
                                _vm.pm.hsCodeChangeHandler(val)
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.hsCode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "hsCode", $$v)
                          },
                          expression: "form.hsCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        { attrs: { slot: "label" }, slot: "label" },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("SeaExport.ChineseDescriptionOfGoods")
                              )
                            )
                          ]),
                          _c("br"),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isEdit,
                                  expression: "isEdit"
                                }
                              ],
                              attrs: {
                                no: "ChineseDescriptionOfGoods",
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  _vm.showHsCodeSearchDialog(
                                    _vm.$t("Message.SelectCargoChineseName"),
                                    function(p) {
                                      return (_vm.form.cargoChineseName =
                                        p.commodityName)
                                    }
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Search")) + " ")]
                          )
                        ],
                        1
                      ),
                      _c("cargo-rich-textarea", {
                        class:
                          _vm.importDifferenceField.cargoEnglishName ||
                          _vm.form.cargoChineseNameWarning === 1
                            ? "red-border"
                            : "",
                        staticStyle: { height: "110px" },
                        attrs: {
                          no: "cargoChineseName",
                          disabled: !_vm.isEdit,
                          "auto-uppercase": false,
                          "auto-half-word": false,
                          "wrap-symbol": "r"
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.ChineseDescriptionOfGoods"),
                              _vm.form.cargoChineseName,
                              function(val) {
                                _vm.form.cargoChineseName = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.cargoChineseName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "cargoChineseName", $$v)
                          },
                          expression: "form.cargoChineseName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.CategoryOfGoods") }
                    },
                    [
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.cargoCode
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "cargoCode",
                          "select-type":
                            _vm.selectTypeNames.basic_data_CargoInformation,
                          disabled:
                            _vm.readonly ||
                            _vm.canEditInternalDelegatedJobField,
                          filterable: "",
                          clearable: true,
                          "default-value": _vm.form.cargoCode,
                          "allow-create": false
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.cargoCodeChange(p.value)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        class: _vm.importDifferenceField.cargoName
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "cargoName",
                          disabled:
                            !(_vm.isEdit && _vm.form.cargoCode) ||
                            _vm.canEditInternalDelegatedJobField
                        },
                        model: {
                          value: _vm.form.cargoName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "cargoName", $$v)
                          },
                          expression: "form.cargoName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section form-column" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "108px",
                    "label-position": "right"
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.OperationInfo")))
                  ]),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.SalesCompany")))]
                      ),
                      _c("el-input", {
                        class: _vm.importDifferenceField.salesOffice
                          ? "red-border"
                          : "",
                        attrs: { value: _vm.txtSalesOffice, disabled: true }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Sales")))]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between"
                        }
                      },
                      [
                        _c("cargo-user-select", {
                          ref: "sales",
                          class: _vm.importDifferenceField.sales
                            ? "red-border"
                            : "",
                          staticStyle: { flex: "1" },
                          attrs: {
                            no: "sales",
                            disabled: !_vm.saleEnabled,
                            "method-params": {
                              officeId: _vm.salesOfficeCheck
                                ? _vm.$store.getters.currentOfficeId
                                : "",
                              category: "role",
                              shape: "sales"
                            },
                            "default-value": _vm.form.sales || "",
                            "static-options": _vm.salesList,
                            placeholder: _vm.salesPrompt,
                            "merge-load": true
                          },
                          on: {
                            change: function(p) {
                              _vm.form.salesRecord = p.value
                              _vm.pm.salesChangeHandler(p)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "margin-left": "5px" },
                            attrs: { no: "provisioned", disabled: true },
                            model: {
                              value: _vm.form.provisioned,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "provisioned", $$v)
                              },
                              expression: "form.provisioned"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Accrued")) + " ")]
                        )
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SalesOfGoods") } },
                    [
                      _c("cargo-user-select", {
                        class: _vm.importDifferenceField.cargoSalesId
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "cargoSalesId",
                          "method-params": {
                            category: "role",
                            shape: "salesOfGoods"
                          },
                          "default-value": _vm.form.cargoSalesId || "",
                          "merge-load": true,
                          "static-options": _vm.cargoSalesList
                        },
                        on: {
                          change: function(p) {
                            _vm.form.cargoSalesId = p.value
                            _vm.pm.cargoSalesChargeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.SalesDepartment")))]
                      ),
                      _c("cargo-department-new-select", {
                        class: _vm.importDifferenceField.salesDepartment
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "salesOffice",
                          disabled: !_vm.form.sales,
                          "sales-id": Number(_vm.form.sales),
                          "office-id": _vm.form.salesOffice,
                          enables: true,
                          "department-id": Number(_vm.form.salesDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.salesDepartment = p.value
                            _vm.pm.departmentChargeHandler()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.OperationCompany") } },
                    [
                      _c("cargo-office-select", {
                        class: _vm.importDifferenceField.opOffice
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "opOffice",
                          disabled:
                            (!_vm.isRegionalCommission &&
                              _vm.pm.isEntrustOrder(true)) ||
                            _vm.opOfficeDisabled,
                          "is-regional-commission": _vm.isRegionalCommission,
                          "office-id": Number(_vm.form.opOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.opOffice = p.value
                            _vm.form.opDepartment = 0
                            _vm.pm.opOfficeChangeHandler()
                            _vm.contractRuleFieldChange(
                              _vm.form.customerId,
                              _vm.form.designationAgent
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.OperationDepartment"))
                          )
                        ]
                      ),
                      _c("cargo-department-select", {
                        class: _vm.importDifferenceField.opDepartment
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "opDepartment",
                          disabled: _vm.pm.isWithinCloseAccountDate,
                          "office-id": Number(_vm.form.opOffice),
                          enables: true,
                          "department-id": Number(_vm.form.opDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.opDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Operation") } },
                    [
                      _c("cargo-user-select", {
                        ref: "op",
                        class: _vm.importDifferenceField.op ? "red-border" : "",
                        attrs: {
                          no: "op",
                          disabled: !_vm.opEabled,
                          "method-params": {
                            officeId: _vm.form.opOffice,
                            category: "role",
                            shape: "op"
                          },
                          "default-value": _vm.form.op || "",
                          "merge-load": true,
                          "static-options": _vm.userPortRoleData.op
                        },
                        on: {
                          change: function(p) {
                            _vm.form.op = p.value
                            _vm.pm.txtOPChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomerOffice") } },
                    [
                      _c("cargo-office-select", {
                        class: _vm.importDifferenceField.csrOffice
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "csrOffice",
                          disabled: true,
                          "office-id": Number(_vm.form.csrOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.csrOffice = p.value
                            _vm.form.csrDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(_vm._s(_vm.$t("Message.Customer_Service")))
                      ]),
                      _c("cargo-department-select", {
                        class: _vm.importDifferenceField.csrDepartment
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "csrDepartment",
                          "office-id": Number(_vm.form.csrOffice),
                          enables: true,
                          "department-id": Number(_vm.form.csrDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.csrDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomerService") } },
                    [
                      _c("cargo-user-select", {
                        ref: "csr",
                        class: _vm.importDifferenceField.csr
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "csr",
                          "method-params": {
                            officeId:
                              _vm.pm.isEntrustOrder ||
                              _vm.form.salesOffice === 1
                                ? _vm.form.opOffice
                                : _vm.form.salesOffice,
                            category: "role",
                            shape: "csr"
                          },
                          "default-value": _vm.form.csr || "",
                          "merge-load": true,
                          "static-options": _vm.userPortRoleData.csr
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.csrChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.FieldOperation") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          "method-params": {
                            officeId: _vm.form.opOffice,
                            category: "role",
                            shape: "siteOp"
                          },
                          "default-value": _vm.form.siteOP || "",
                          "static-options": _vm.userPortRoleData.siteOp
                        },
                        on: {
                          change: function(p) {
                            _vm.JobUtils.siteOpChangeHandler(_vm.form, p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.OverseaCustomerService")
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "overseaOp",
                        attrs: {
                          no: "overseaOp",
                          "default-value": _vm.form.overseaOp || "",
                          "method-params": {
                            category: "role",
                            shape: "overseaOp"
                          },
                          "static-options": _vm.isHC
                            ? null
                            : _vm.userPortRoleData.overseaOp ||
                              _vm.overseaAgentUsersList,
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.form.overseaOp = p.value
                            _vm.pm.overseaOpChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.DocumentOffice") } },
                    [
                      _c("cargo-office-select", {
                        class: _vm.importDifferenceField.dcOffice
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "dcOffice",
                          disabled: true,
                          "office-id": Number(_vm.form.dcOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.dcOffice = p.value
                            _vm.form.dcDepartment = 0 /* ;pm.dcOfficeChangeHandler() */
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("Message.Documentation_Department"))
                        )
                      ]),
                      _c("cargo-department-select", {
                        class: _vm.importDifferenceField.dcDepartment
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "dcDepartment",
                          "office-id": Number(_vm.form.dcOffice),
                          enables: true,
                          "department-id": Number(_vm.form.dcDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.dcDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Documents") } },
                    [
                      _c("cargo-user-select", {
                        ref: "dc",
                        class: _vm.importDifferenceField.dc ? "red-border" : "",
                        attrs: {
                          no: "dc",
                          "method-params": {
                            officeId: _vm.form.opOffice,
                            category: "role",
                            shape: "doc"
                          },
                          "default-value": _vm.form.dc || "",
                          "merge-load": true,
                          "static-options": _vm.userPortRoleData.doc
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.dcChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.AirlineOffice") } },
                    [
                      _c("cargo-office-select", {
                        class: _vm.importDifferenceField.plannerOffice
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "plannerOffice",
                          disabled: true,
                          "office-id": Number(_vm.form.plannerOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.plannerOffice = p.value
                            _vm.form.plannerDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.AirlineDepartment")))
                      ]),
                      _c("cargo-department-select", {
                        class: _vm.importDifferenceField.plannerDepartment
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "plannerDepartment",
                          "office-id": Number(_vm.form.plannerOffice),
                          enables: true,
                          "department-id": Number(_vm.form.plannerDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.plannerDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.AirlinePerson2") } },
                    [
                      _c("cargo-user-select", {
                        class: _vm.importDifferenceField.planner
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "planner",
                          "method-params": {
                            officeId: _vm.form.opOffice,
                            category: "role",
                            shape: "seaLine"
                          },
                          "default-value": _vm.form.planner || "",
                          "merge-load": true,
                          "static-options": _vm.userPortRoleData.seaLine
                        },
                        on: {
                          change: function(p) {
                            _vm.form.planner = p.value
                            _vm.pm.txtPlannerChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isAddUserDefinedRoles,
                          expression: "isAddUserDefinedRoles"
                        }
                      ],
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_userDefinedRole1")
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId1",
                        attrs: {
                          no: "userDefinedRoleId1",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole1"
                          },
                          "default-value": _vm.form.userDefinedRoleId1 || "",
                          "merge-load": true,
                          "static-options":
                            _vm.userPortRoleData.userDefinedRole1
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId1Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isAddUserDefinedRoles,
                          expression: "isAddUserDefinedRoles"
                        }
                      ],
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_userDefinedRole2")
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId2",
                        attrs: {
                          no: "userDefinedRoleId2",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole2"
                          },
                          "default-value": _vm.form.userDefinedRoleId2 || "",
                          "merge-load": true,
                          "static-options":
                            _vm.userPortRoleData.userDefinedRole2
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId2Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  this.$store.getters.tenantId === 889
                    ? _c(
                        "div",
                        [
                          _c("micro-app", {
                            attrs: {
                              name: "child-user-defined-role",
                              url:
                                _vm.$store.getters.frontEndPluginUrl +
                                "/userDefinedRoleItem",
                              "router-mode": "pure",
                              destroy: ""
                            },
                            on: { datachange: _vm.userDefinedRoleDataChange }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("special-requests-grid", {
                    ref: "selectedSpecialRequest",
                    staticStyle: { "margin-bottom": "5px" },
                    attrs: {
                      no: "satisfiedRequests",
                      "is-edit": _vm.isEdit,
                      "customer-id": Number(_vm.form.customerId),
                      lob: _vm.form.lob,
                      job: _vm.form
                    },
                    model: {
                      value: _vm.form.satisfiedRequests,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "satisfiedRequests", $$v)
                      },
                      expression: "form.satisfiedRequests"
                    }
                  })
                ],
                1
              ),
              !_vm.toExoSystemJYD
                ? _c(
                    "el-form",
                    {
                      attrs: {
                        disabled: _vm.lockJobByPrintHblZb
                          ? false
                          : _vm.readonly,
                        "label-width": "108px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.OperationRequirements")
                          }
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: _vm.form.operationContent,
                                placement: "left"
                              }
                            },
                            [
                              _c("div", {
                                attrs: { slot: "content" },
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.form.operationContent
                                      ? _vm.form.operationContent.replace(
                                          /[\n]/g,
                                          "</br>"
                                        )
                                      : _vm.$t("SeaExport.NoData")
                                  )
                                },
                                slot: "content"
                              }),
                              _c("el-input", {
                                attrs: {
                                  no: "operationContent",
                                  value: _vm.form.operationContent,
                                  placeholder: _vm.readonly
                                    ? ""
                                    : _vm.$t(
                                        "SeaExport.DoubleClickToAddOperationRequirements"
                                      ),
                                  type: "textarea",
                                  rows: 4
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    _vm.selectOperationReqDialog.value =
                                      _vm.form.operationContent
                                    _vm.selectOperationReqDialog.visible =
                                      _vm.isEdit || _vm.lockJobByPrintHblZb
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.OperationTips") } },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "operationTips",
                              type: "textarea",
                              rows: 4
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.OperationTips"),
                                  _vm.form.operationTips,
                                  function(val) {
                                    _vm.form.operationTips = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.operationTips,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "operationTips", $$v)
                              },
                              expression: "form.operationTips"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "108px",
                    "label-position": "right"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ExtraChargeClause") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "txtSurchargeTerms",
                          value: _vm.txtSurchargeTerms,
                          placeholder: _vm.readonly
                            ? ""
                            : _vm.$t(
                                "SeaExport.DoubleClickToAddExtraChargeClause"
                              ),
                          type: "textarea",
                          rows: 4
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.selectSurchargeTermsDialog.rowData =
                              _vm.form.surchargeTerms
                            _vm.selectSurchargeTermsDialog.visible = true
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.WarehousingInfo") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "txtWhs",
                          disabled: true,
                          type: "textarea",
                          rows: 4,
                          value: _vm.txtWhs
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              !_vm.toExoSystemJYD
                ? _c(
                    "el-form",
                    {
                      attrs: {
                        disabled: _vm.lockJobByPrintHblZb
                          ? false
                          : _vm.readonly,
                        "label-width": "108px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Remarks") } },
                        [
                          _c("el-input", {
                            attrs: { no: "remarks", type: "textarea", rows: 4 },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.Remarks"),
                                  _vm.form.remarks,
                                  function(val) {
                                    _vm.form.remarks = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.remarks,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "remarks", $$v)
                              },
                              expression: "form.remarks"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm.isFba
            ? _c(
                "div",
                { staticClass: "section form-column" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        disabled: _vm.readonly,
                        "label-width": "120px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s("FBA"))
                      ]),
                      !_vm.isEdit
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.ServiceChannel")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "serviceChannel",
                                  disabled: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_FbaChannel,
                                  filterable: "",
                                  "method-params": {
                                    shippingType: _vm.fbaJob.shippingType,
                                    active: true
                                  },
                                  clearable: true,
                                  "default-value": _vm.fbaJob.serviceChannel
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.fbaJob.serviceChannel = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isEdit
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.ServiceChannel")
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { filterable: "", clearable: "" },
                                  on: { change: _vm.changeServiceChannel },
                                  model: {
                                    value: _vm.fbaJob.serviceChannel,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.fbaJob,
                                        "serviceChannel",
                                        $$v
                                      )
                                    },
                                    expression: "fbaJob.serviceChannel"
                                  }
                                },
                                _vm._l(_vm.channel4JobSelect, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.channelName,
                                      value: item.channelName
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.EstimatedStorageReadyGoodsTime"
                                  )
                                )
                              )
                            ]
                          ),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "preWarehousingTime",
                              type: "datetime",
                              clearable: "",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.preWarehousingChangeHandler()
                              }
                            },
                            model: {
                              value: _vm.fbaJob.preWarehousingTime,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "preWarehousingTime", $$v)
                              },
                              expression: "fbaJob.preWarehousingTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.ExpectedAmazonWarehouseEntryTime"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "preAmazonWhTime",
                              disabled: _vm.readonly,
                              type: "date",
                              clearable: "",
                              "value-format": "yyyy-MM-dd",
                              format: "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.fbaJob.preAmazonWhTime,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "preAmazonWhTime", $$v)
                              },
                              expression: "fbaJob.preAmazonWhTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c("el-form-item", [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Destination")))]
                        ),
                        _c(
                          "div",
                          { staticStyle: { display: "flex", flex: "1" } },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.fbaJob.warehouseCode,
                                  placement: "bottom-end"
                                }
                              },
                              [
                                _c("el-cascader", {
                                  staticStyle: {
                                    width: "91px",
                                    "padding-right": "2px"
                                  },
                                  attrs: {
                                    options: _vm.destinations,
                                    filterable: "",
                                    clearable: true
                                  },
                                  on: {
                                    focus: function($event) {
                                      return _vm.JobUtils.focusWarehouseCode(
                                        _vm.fbaJob
                                      )
                                    },
                                    blur: function($event) {
                                      return _vm.JobUtils.blurWarehouseCode(
                                        _vm.fbaJob
                                      )
                                    },
                                    change: function(p) {
                                      _vm.JobUtils.warehouseCodeHandler(
                                        _vm.fbaJob,
                                        p
                                      )
                                      _vm.changeWarehouseCode
                                    }
                                  },
                                  model: {
                                    value: _vm.fbaJob.warehouseCode,
                                    callback: function($$v) {
                                      _vm.$set(_vm.fbaJob, "warehouseCode", $$v)
                                    },
                                    expression: "fbaJob.warehouseCode"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-checkbox",
                              {
                                attrs: { no: "remoteWarehouse" },
                                model: {
                                  value: _vm.fbaJob.remoteWarehouse,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "remoteWarehouse", $$v)
                                  },
                                  expression: "fbaJob.remoteWarehouse"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.RemoteWarehouse"))
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Warehouse.DestinationCountry")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: true, no: "country" },
                            model: {
                              value: _vm.fbaJob.country,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "country", $$v)
                              },
                              expression: "fbaJob.country"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.ZIP") } },
                        [
                          _c("el-input", {
                            attrs: { disabled: true, no: "zipCode" },
                            model: {
                              value: _vm.fbaJob.zipCode,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "zipCode", $$v)
                              },
                              expression: "fbaJob.zipCode"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.DestinationDeliveryMethod")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                no: "destinationDistribution",
                                filterable: ""
                              },
                              on: { change: _vm.destinationDistributionChange },
                              model: {
                                value: _vm.fbaJob.destinationDistribution,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.fbaJob,
                                    "destinationDistribution",
                                    $$v
                                  )
                                },
                                expression: "fbaJob.destinationDistribution"
                              }
                            },
                            _vm._l(
                              _vm.FbaJobConstants
                                .ORDER_DESTINATION_DISTRIBUTION_TYPES,
                              function(item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label:
                                      _vm.$store.getters.language === "zh"
                                        ? item.chineseName
                                        : item.englishName,
                                    value: item.code
                                  }
                                })
                              }
                            ),
                            1
                          )
                        ],
                        1
                      ),
                      _vm.fbaJob.destinationDistribution &&
                      Number(_vm.fbaJob.destinationDistribution) === 1
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.CourierCompany")
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    no: "expressCompany",
                                    placeholder: "",
                                    clearable: ""
                                  },
                                  model: {
                                    value: _vm.fbaJob.expressCompany,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.fbaJob,
                                        "expressCompany",
                                        $$v
                                      )
                                    },
                                    expression: "fbaJob.expressCompany"
                                  }
                                },
                                _vm._l(
                                  _vm.FbaJobConstants.EXPRESS_COMPANYS,
                                  function(item) {
                                    return _c("el-option", {
                                      key: item.code,
                                      attrs: {
                                        label: item.chineseName,
                                        value: item.code
                                      }
                                    })
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.fbaJob.destinationDistribution &&
                      Number(_vm.fbaJob.destinationDistribution) === 1
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.TrackingNumber")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "expressNo" },
                                model: {
                                  value: _vm.fbaJob.expressNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "expressNo", $$v)
                                  },
                                  expression: "fbaJob.expressNo"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.POoriginalNumber") }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "poNumber" },
                            model: {
                              value: _vm.fbaJob.poNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "poNumber", $$v)
                              },
                              expression: "fbaJob.poNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Shipment Id" } },
                        [
                          _c("el-input", {
                            attrs: { no: "shipmentId" },
                            model: {
                              value: _vm.fbaJob.shipmentId,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "shipmentId", $$v)
                              },
                              expression: "fbaJob.shipmentId"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Reference Id" } },
                        [
                          _c("el-input", {
                            attrs: { no: "referenceId" },
                            model: {
                              value: _vm.fbaJob.referenceId,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "referenceId", $$v)
                              },
                              expression: "fbaJob.referenceId"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.$t("FbaJob.ChargingMethod")))]
                          ),
                          _c(
                            "el-radio-group",
                            {
                              attrs: { no: "chargingMethod" },
                              on: { change: _vm.chargingMethodChange },
                              model: {
                                value: _vm.fbaJob.chargingMethod,
                                callback: function($$v) {
                                  _vm.$set(_vm.fbaJob, "chargingMethod", $$v)
                                },
                                expression: "fbaJob.chargingMethod"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v(_vm._s("KG"))
                              ]),
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v(_vm._s("CBM"))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("FbaJob.BubbleCountingRatio") }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: { no: "bubbleCountingRatio" },
                            on: { change: _vm.bubbleCountingChange },
                            model: {
                              value: _vm.fbaJob.bubbleCountingRatio,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "bubbleCountingRatio", $$v)
                              },
                              expression: "fbaJob.bubbleCountingRatio"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.pbProportion") } },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex", flex: "1" } },
                            [
                              _c("el-input", {
                                attrs: { no: "bubbleSplittingRatio" },
                                on: { change: _vm.bubbleSplittingRatioChange },
                                model: {
                                  value: _vm.fbaJob.bubbleSplittingRatio,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.fbaJob,
                                      "bubbleSplittingRatio",
                                      $$v
                                    )
                                  },
                                  expression: "fbaJob.bubbleSplittingRatio"
                                }
                              }),
                              _vm._v("% ")
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.CustomsDeclarationMethod")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "customsMethodPol",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CustomsMode,
                              "method-params": { serviceType: 0 },
                              filterable: "",
                              clearable: false,
                              "default-value": _vm.fbaJob.customsMethodPol
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.fbaJob.customsMethodPol = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.ClearanceMethod") }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "customsMethodPod",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CustomsMode,
                              "method-params": { serviceType: 1 },
                              filterable: "",
                              clearable: false,
                              "default-value": _vm.fbaJob.customsMethodPod
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.fbaJob.customsMethodPod = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.EORIEnterpriseNumber")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "eoriNo" },
                            model: {
                              value: _vm.fbaJob.eoriNo,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "eoriNo", $$v)
                              },
                              expression: "fbaJob.eoriNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.VATTaxNumber") } },
                        [
                          _c("el-input", {
                            attrs: { no: "vatNo" },
                            model: {
                              value: _vm.fbaJob.vatNo,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "vatNo", $$v)
                              },
                              expression: "fbaJob.vatNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.VATRegistrationCountry")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "taxRegisterCountry",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Country,
                              filterable: "",
                              "callback-params": { key: "taxRegisterCountry" },
                              "callback-method-type": "value",
                              "default-value": _vm.fbaJob.taxRegisterCountry
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.fbaJob.taxRegisterCountry = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.VATRegistrationAddress")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "taxRegisterAddress" },
                            model: {
                              value: _vm.fbaJob.taxRegisterAddress,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "taxRegisterAddress", $$v)
                              },
                              expression: "fbaJob.taxRegisterAddress"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.VATCompanyEnglishName")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "taxCompany" },
                            model: {
                              value: _vm.fbaJob.taxCompany,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "taxCompany", $$v)
                              },
                              expression: "fbaJob.taxCompany"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "section form-column" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: _vm.lockJobByPrintHblZb ? false : _vm.readonly,
                    "label-width": "100px",
                    "label-position": "right"
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.UserDefinedArea")))
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.UserDefinedField1") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "userDefinedField1",
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.UserDefinedField1"),
                              _vm.form.userDefinedField1,
                              function(val) {
                                _vm.form.userDefinedField1 = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.userDefinedField1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "userDefinedField1", $$v)
                          },
                          expression: "form.userDefinedField1"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.UserDefinedField2") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "userDefinedField2",
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.UserDefinedField2"),
                              _vm.form.userDefinedField2,
                              function(val) {
                                _vm.form.userDefinedField2 = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.userDefinedField2,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "userDefinedField2", $$v)
                          },
                          expression: "form.userDefinedField2"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.UserDefinedField3") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "userDefinedField3",
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.UserDefinedField3"),
                              _vm.form.userDefinedField3,
                              function(val) {
                                _vm.form.userDefinedField3 = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.userDefinedField3,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "userDefinedField3", $$v)
                          },
                          expression: "form.userDefinedField3"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.UserDefinedField4") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "userDefinedField4",
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.UserDefinedField4"),
                              _vm.form.userDefinedField4,
                              function(val) {
                                _vm.form.userDefinedField4 = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.userDefinedField4,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "userDefinedField4", $$v)
                          },
                          expression: "form.userDefinedField4"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.TaxNature") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "taxNature",
                            placeholder: _vm.$t("SeaExport.PleaseSelect"),
                            size: "mini"
                          },
                          model: {
                            value: _vm.form.taxNature,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "taxNature", $$v)
                            },
                            expression: "form.taxNature"
                          }
                        },
                        _vm._l(_vm.TAX_NATURES, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "section", staticStyle: { width: "100%" } }, [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.CustomerDeliveryInfo")))
          ]),
          _c(
            "div",
            [
              !_vm.isFba
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        no: "CodeSearching",
                        disabled: _vm.readonly,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          _vm.billAddressDialog.visible = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                  )
                : _vm._e(),
              _vm.isFba
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        no: "FbaCodeSearching",
                        disabled: _vm.readonly,
                        type: "primary"
                      },
                      on: { click: _vm.fbaCodeSearchBtn }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "form-row",
              staticStyle: {
                display: "flex",
                "flex-direction": "row",
                "margin-top": "8px"
              }
            },
            [
              _c(
                "el-form",
                {
                  staticStyle: { position: "relative", "margin-right": "10px" },
                  attrs: { "label-width": "50px", "label-position": "left" }
                },
                [
                  _c("char-count", {
                    attrs: { form: _vm.form, prefix: "shipper" }
                  }),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Shipper") } },
                    [
                      _c("cargo-input", {
                        class: _vm.importDifferenceField.shipperCode
                          ? "red-border"
                          : "",
                        staticStyle: { width: "115px", "margin-right": "5px" },
                        attrs: {
                          no: "shipperCode",
                          placeholder: _vm.readonly
                            ? ""
                            : _vm.$t("SeaExport.ShipperId"),
                          "auto-uppercase":
                            _vm.notUppercaseShipperConsigneNotify,
                          disabled: _vm.readonly
                        },
                        model: {
                          value: _vm.form.shipperCode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "shipperCode", $$v)
                          },
                          expression: "form.shipperCode"
                        }
                      }),
                      _c("cargo-company-select", {
                        class: _vm.importDifferenceField.shipperId
                          ? "red-border"
                          : "",
                        staticStyle: {
                          display: "inline-block",
                          width: "145px"
                        },
                        attrs: {
                          no: "shipperId",
                          disabled: _vm.readonly,
                          "method-params": { shipper: true, active: true },
                          "default-value": _vm.form.shipperId || ""
                        },
                        on: {
                          change: function(data) {
                            _vm.pm.shipperChange(data)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._l(7, function(i) {
                    return _c(
                      "el-form-item",
                      { key: i, attrs: { "label-width": "0" } },
                      [
                        _c(
                          "special-character-tip",
                          {
                            attrs: {
                              texts: _vm.specialCharCheck["shipperLine" + i]
                            }
                          },
                          [
                            _c("cargo-input", {
                              ref: "shipperLine" + i,
                              refInFor: true,
                              class: _vm.importDifferenceField[
                                "shipperLine" + i
                              ]
                                ? "red-border"
                                : "",
                              attrs: {
                                "use-read-only": true,
                                disabled: _vm.readonly,
                                no: "shipperLine" + i,
                                placeholder: _vm.placeholderSFT(i),
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "shipperLine" + i,
                                    i + 1 > 6 ? null : "shipperLine" + (i + 1),
                                    200
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    _vm.$t("SeaExport.Shipper"),
                                    _vm.mergeShipperLine(),
                                    _vm.splitShipperLine,
                                    _vm.notUppercaseShipperConsigneNotify,
                                    {
                                      autoHalfWord: true,
                                      autoUppercase:
                                        _vm.notUppercaseShipperConsigneNotify
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.form["shipperLine" + i],
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "shipperLine" + i, $$v)
                                },
                                expression: "form['shipperLine'+i]"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              ),
              _c(
                "el-form",
                {
                  staticStyle: { position: "relative", "margin-right": "20px" },
                  attrs: { "label-width": "65px", "label-position": "left" }
                },
                [
                  _c("char-count", {
                    attrs: { form: _vm.form, prefix: "consignee" }
                  }),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Consignee") } },
                    [
                      _c("cargo-input", {
                        class: _vm.importDifferenceField.consigneeCode
                          ? "red-border"
                          : "",
                        staticStyle: { width: "115px", "margin-right": "5px" },
                        attrs: {
                          no: "consigneeCode",
                          placeholder: _vm.readonly
                            ? ""
                            : _vm.$t("SeaExport.ConsigneeId"),
                          "auto-uppercase":
                            _vm.notUppercaseShipperConsigneNotify,
                          disabled: _vm.readonly
                        },
                        model: {
                          value: _vm.form.consigneeCode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "consigneeCode", $$v)
                          },
                          expression: "form.consigneeCode"
                        }
                      }),
                      _c("cargo-company-select", {
                        class: _vm.importDifferenceField.consigneeId
                          ? "red-border"
                          : "",
                        staticStyle: {
                          display: "inline-block",
                          width: "145px"
                        },
                        attrs: {
                          no: "consigneeId",
                          disabled: _vm.readonly,
                          "method-params": { consignee: true, active: true },
                          "default-value": _vm.form.consigneeId || ""
                        },
                        on: {
                          change: function(data) {
                            _vm.pm.consigneeChange(data)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._l(7, function(i) {
                    return _c(
                      "el-form-item",
                      { key: i, attrs: { "label-width": "0" } },
                      [
                        _c(
                          "special-character-tip",
                          {
                            attrs: {
                              texts: _vm.specialCharCheck["consigneeLine" + i]
                            }
                          },
                          [
                            _c("cargo-input", {
                              ref: "consigneeLine" + i,
                              refInFor: true,
                              class: _vm.importDifferenceField[
                                "consigneeLine" + i
                              ]
                                ? "red-border"
                                : "",
                              attrs: {
                                disabled: _vm.readonly,
                                no: "consigneeLine" + i,
                                placeholder: _vm.placeholderSFT(i),
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "consigneeLine" + i,
                                    i + 1 > 6
                                      ? null
                                      : "consigneeLine" + (i + 1),
                                    200
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    _vm.$t("SeaExport.Consignee"),
                                    _vm.mergeConsigneeLine(),
                                    _vm.splitConsigneeLine,
                                    _vm.notUppercaseShipperConsigneNotify,
                                    {
                                      autoHalfWord: true,
                                      autoUppercase:
                                        _vm.notUppercaseShipperConsigneNotify
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.form["consigneeLine" + i],
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "consigneeLine" + i, $$v)
                                },
                                expression: "form['consigneeLine'+i]"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              ),
              _c(
                "el-form",
                {
                  staticStyle: { position: "relative", "margin-right": "20px" },
                  attrs: { "label-width": "50px", "label-position": "left" }
                },
                [
                  _c("char-count", {
                    attrs: { form: _vm.form, prefix: "notify" }
                  }),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.NotifyParty") } },
                    [
                      _c("cargo-input", {
                        class: _vm.importDifferenceField.notifyCode
                          ? "red-border"
                          : "",
                        staticStyle: { width: "115px", "margin-right": "5px" },
                        attrs: {
                          no: "notifyCode",
                          placeholder: _vm.readonly
                            ? ""
                            : _vm.$t("SeaExport.NotifyId"),
                          "auto-uppercase":
                            _vm.notUppercaseShipperConsigneNotify,
                          disabled: _vm.readonly
                        },
                        model: {
                          value: _vm.form.notifyCode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "notifyCode", $$v)
                          },
                          expression: "form.notifyCode"
                        }
                      }),
                      _c("cargo-company-select", {
                        class: _vm.importDifferenceField.notifyId
                          ? "red-border"
                          : "",
                        staticStyle: {
                          display: "inline-block",
                          width: "145px"
                        },
                        attrs: {
                          no: "notifyId",
                          disabled: _vm.readonly,
                          "method-params": { notify: true, active: true },
                          "default-value": _vm.form.notifyId || ""
                        },
                        on: {
                          change: function(data) {
                            _vm.pm.notifyChange(data)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._l(7, function(i) {
                    return _c(
                      "el-form-item",
                      { key: i, attrs: { "label-width": "0" } },
                      [
                        _c(
                          "special-character-tip",
                          {
                            attrs: {
                              texts: _vm.specialCharCheck["notifyLine" + i]
                            }
                          },
                          [
                            _c("cargo-input", {
                              ref: "notifyLine" + i,
                              refInFor: true,
                              class: _vm.importDifferenceField["notifyLine" + i]
                                ? "red-border"
                                : "",
                              attrs: {
                                disabled: _vm.readonly,
                                no: "notifyLine" + i,
                                placeholder: _vm.placeholderSFT(i),
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "notifyLine" + i,
                                    i + 1 > 6 ? null : "notifyLine" + (i + 1),
                                    200
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    _vm.$t("SeaExport.NotifyParty"),
                                    _vm.mergeNotifyLine(),
                                    _vm.splitNotifyLine,
                                    _vm.notUppercaseShipperConsigneNotify,
                                    {
                                      autoHalfWord: true,
                                      autoUppercase:
                                        _vm.notUppercaseShipperConsigneNotify
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.form["notifyLine" + i],
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "notifyLine" + i, $$v)
                                },
                                expression: "form['notifyLine'+i]"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              ),
              _c(
                "div",
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        display: "inline-block",
                        "line-height": "28px",
                        "padding-bottom": "5px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.SecondNotifyParty")))]
                  ),
                  _c("cargo-rich-textarea", {
                    class: _vm.importDifferenceField.alsoNotify
                      ? "red-border"
                      : "",
                    staticStyle: { width: "310px", height: "230px" },
                    attrs: {
                      no: "alsoNotify",
                      disabled: _vm.readonly,
                      "text-chars": 0,
                      "wrap-symbol": "r"
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.SecondNotifyParty"),
                          _vm.form.alsoNotify,
                          function(val) {
                            _vm.form.alsoNotify = val
                          },
                          _vm.notUppercaseShipperConsigneNotify,
                          {
                            warningCount: 45,
                            maxChar: 0,
                            autoHalfWord: true,
                            autoUppercase: _vm.notUppercaseShipperConsigneNotify
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.alsoNotify,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "alsoNotify", $$v)
                      },
                      expression: "form.alsoNotify"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "ContactPerson",
            visible: _vm.contactDialog.visible,
            title: _vm.$t("SeaExport.ContactPerson"),
            width: "400px",
            "append-to-body": "",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.contactDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-position": "right", "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.ContactPerson") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.contactPerson
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Role") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.role
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Tel") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.telephone
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Mobile") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.mobile
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Fax") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: { disabled: true, value: _vm.contactDialog.data.fax }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Email") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.email
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.remarks,
                      type: "textarea",
                      rows: 3
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "advanceTextDialog",
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            },
            close: _vm.closeAdvanceText
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "320px" },
            attrs: {
              no: "advanceTextDialogTextarea",
              disabled: _vm.readonly,
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              "auto-half-word": _vm.advanceTextDialog.formatObj.autoHalfWord,
              "auto-uppercase": _vm.advanceTextDialog.formatObj.autoUppercase
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { no: "advanceTextDialogConfirm", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "advanceTextDialogClose" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                      _vm.closeAdvanceText()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("sop-dialog", {
        attrs: {
          visible: _vm.sopDialog.visible,
          "cmp-idx": _vm.sopDialog.cmpIdx,
          job: _vm.form,
          agent: _vm.sopDialog.agent,
          lob: "SE",
          "contact-list": _vm.sopDialog.contactList
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.sopDialog, "visible", $event)
          },
          updateJob: function($event) {
            return _vm.$emit("updateJob")
          }
        }
      }),
      _c("transcribe-dialog", {
        attrs: { visible: _vm.transcribeDialog.visible, job: _vm.form },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.transcribeDialog, "visible", $event)
          },
          callback: _vm.transcribeCallback
        }
      }),
      _c("hs-code-search-dialog", {
        attrs: {
          visible: _vm.hsCodeSearchDialog.visible,
          title: _vm.hsCodeSearchDialog.title
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.hsCodeSearchDialog, "visible", $event)
          },
          callback: _vm.hsCodeSearchDialog.successCallback
        }
      }),
      _c("select-operation-req-dialog", {
        attrs: {
          visible: _vm.selectOperationReqDialog.visible,
          lob: "SE",
          value: _vm.selectOperationReqDialog.value
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.selectOperationReqDialog, "visible", $event)
          },
          callback: function(val) {
            return (_vm.form.operationContent = val)
          }
        }
      }),
      _c("select-surcharge-terms-dialog", {
        attrs: {
          visible: _vm.selectSurchargeTermsDialog.visible,
          "job-uuid": _vm.form.uuid,
          "row-data": _vm.selectSurchargeTermsDialog.rowData,
          disabled: _vm.readonly
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.selectSurchargeTermsDialog, "visible", $event)
          },
          callback: _vm.handleSurchargeTerms
        }
      }),
      _c("bill-address-dialog", {
        attrs: { visible: _vm.billAddressDialog.visible, job: _vm.form },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billAddressDialog, "visible", $event)
          },
          callback: _vm.codeSearchCallback
        }
      }),
      _c("fba-bill-address-dialog", {
        attrs: { visible: _vm.fbaBillAddressDialog.visible, job: _vm.fbaJob },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.fbaBillAddressDialog, "visible", $event)
          },
          callback: _vm.fbaCodeSearchCallback
        }
      }),
      _c("stamp-picture-view", {
        attrs: {
          visible: _vm.stampPictureView.visible,
          "business-documents": _vm.stampPictureView.businessDocuments
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.stampPictureView, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }